window.GCQuestions = {
  pt: {
    daily: [
      "O que aprendi hoje que não estava à espera de aprender?",
      "Em que momento de hoje me senti genuinamente eu próprio?",
      "O que evitei dizer hoje e por que razão?",
      "Que decisão tomei hoje que gostaria de rever amanhã?",
      "Onde é que o meu ego interferiu com o meu trabalho hoje?",
      "O que teria feito diferente se soubesse o resultado com antecedência?",
      "Que conversa de hoje ainda está a ocupar espaço na minha cabeça?",
      "Em que momento perdi o fio à meada e o que me trouxe de volta?",
      "O que fiz hoje por hábito em vez de por escolha consciente?",
      "Que suposição minha foi desafiada hoje?",
      "Em que situação me deixei levar pelo que os outros esperavam de mim?",
      "O que é que o meu corpo me disse hoje que a minha mente ignorou?",
      "Que pessoa hoje me fez pensar de forma diferente?",
      "Onde é que precisei de coragem e não a usei?",
      "O que é que 'feito' significou para mim hoje?",
      "Em que momento do dia me senti mais vivo?",
      "Que problema de hoje era realmente um sintoma de outra coisa?",
      "O que é que deleguei hoje quando devia ter feito eu próprio?",
      "Que reunião de hoje teria sido melhor como uma conversa de corredor?",
      "Em que momento fui mais líder do que gestor?",
      "O que é que fiz bem hoje que não reconheci em voz alta?",
      "Que padrão negativo repeti hoje que reconheço de outros dias?",
      "Onde é que confundi urgência com importância?",
      "Que ideia surgiu hoje que ainda não desenvolvi?",
      "Em que situação me comportei de forma diferente do que os meus valores preconizam?",
      "O que é que o silêncio de alguém me disse hoje?",
      "Que pergunta ficou sem resposta no fim do dia?",
      "Em que momento senti que estava a liderar para fora e não para dentro?",
      "O que teria acontecido se tivesse dito não mais cedo hoje?",
      "Que vulnerabilidade mostrei hoje que me custou mostrar?",
      "Onde é que a minha atenção foi para onde não devia ir?",
      "Que conversa de hoje mudou algo, ainda que subtilmente?",
      "Em que momento me senti parte de algo maior do que eu?",
      "O que é que 'progresso' representou para mim hoje?",
      "Que assunção não testada guiou as minhas decisões hoje?",
      "Em que situação ajudei quando devia ter deixado a pessoa resolver sozinha?",
      "Que momento de hoje gostaria de guardar numa cápsula do tempo?",
      "O que é que a minha agenda de hoje revelou sobre as minhas prioridades reais?",
      "Em que situação fui mais honesto do que confortável?",
      "Que coisa simples de hoje teve um impacto que não antecipei?",
      "Onde é que a minha impaciência me custou tempo?",
      "Que história contei hoje sobre mim próprio que pode não ser totalmente verdade?",
      "Em que momento fui mais coach do que chefe?",
      "O que é que ouvi hoje que não queria ouvir mas precisava?",
      "Que pequena vitória de hoje merece mais atenção do que dei?",
      "Em que situação joguei pelo seguro quando podia ter arriscado?",
      "O que é que o feedback que recebi hoje me disse sobre mim?",
      "Que suposição sobre a equipa provei errada hoje?",
      "Em que momento senti que o ambiente me estava a moldar em vez de eu moldar o ambiente?",
      "O que é que 'liderar' significou para mim concretamente hoje?",
      "Que conflito ignorei hoje que vai aparecer amanhã?",
      "Em que situação fiz uma pergunta quando devia ter dado espaço?",
      "O que é que a minha energia no fim do dia me diz sobre como devo começar amanhã?",
      "Que decisão de hoje foi tomada com dados suficientes e qual não foi?",
      "Em que momento perdi a perspetiva sistémica e fiquei preso no detalhe?",
      "Que conversa difícil adiei para amanhã?",
      "Em que situação fui mais reativo do que responsivo?",
      "O que é que o meu cansaço me está a dizer sobre o que preciso de mudar?",
      "Que ideia de outra pessoa melhorei sem lhe dar crédito?",
      "Em que momento de hoje fui autêntico sem planear ser?",
      "O que é que 'responsabilidade' significou na prática hoje?",
      "Que coisa de hoje estava fora do meu controlo e gastei energia a tentar controlar?",
      "Em que situação a minha posição hierárquica ajudou e quando bloqueou?",
      "O que é que não disse em voz alta mas comunicou na mesma?",
      "Que situação de hoje precisava de mais perspetiva e menos resolução?",
      "Em que momento me senti a ser avaliado em vez de a ser apoiado?",
      "O que é que uma criança de dez anos diria sobre o que fiz hoje?",
      "Que padrão de equipa observei hoje que me diz algo sobre a cultura?",
      "Em que situação fui parte do problema e não parte da solução?",
      "O que faria de diferente se soubesse que ninguém estava a observar?",
      "Que momento de hoje vai continuar a trabalhar em mim enquanto durmo?",
      "Em que situação coloquei o processo à frente das pessoas?",
      "O que é que 'suficientemente bom' foi hoje e onde é que era uma desculpa?",
      "Que crença limitante ativei hoje sem me aperceber?",
      "Em que momento de hoje me senti genuinamente curioso em vez de apenas educado?",
      "O que é que a forma como comecei o dia influenciou no resto?",
      "Que situação de hoje teria corrido melhor com mais silêncio da minha parte?",
      "Em que momento fui um espelho para alguém sem o planear?",
      "O que é que o meu sim de hoje custou ao meu não?",
      "Que conversa de hoje abriu algo ou fechou algo?",
      "Em que situação confundi estar ocupado com ser produtivo?",
      "O que perdi a oportunidade de agradecer hoje?",
      "Que momento de hoje foi mais sobre controlo do que sobre confiança?",
      "Em que situação a minha experiência me fechou em vez de me abrir?",
      "O que é que 'crescer' significou para mim hoje, especificamente?",
      "Que pergunta não fiz hoje que podia ter mudado a direção da conversa?",
      "Em que momento me senti mais alinhado entre o que penso, digo e faço?",
      "O que ignoro sistematicamente que hoje voltou a aparecer?",
      "Que decisão tomei hoje que foi movida pelo medo em vez de pela visão?",
      "Em que situação permiti que a minha insegurança tomasse decisões por mim?",
      "O que fiz hoje que só fazia sentido para mim?",
      "Que aprendizagem de hoje foi desconfortável e necessária ao mesmo tempo?",
      "Em que momento a minha presença fez diferença sem eu precisar de dizer nada?",
      "O que é que 'cultura' se comportou hoje na minha equipa?",
      "Em que situação deixei que o perfeccionismo bloqueasse o progresso?",
      "O que é que 'confiança' significou em ação hoje?",
      "Que momento de hoje foi de transição mas passou despercebido?",
      "Em que situação usei dados para esconder uma decisão que já tinha tomado?",
      "O que é que hoje me ensinou sobre o tipo de líder que quero ser?",
      "Que impacto não intencional tive hoje numa pessoa ou numa situação?",
      "Em que momento senti que estava a fazer o trabalho errado da forma certa?",
      "O que é que a minha linguagem corporal disse hoje que as palavras não disseram?",
      "Que situação de hoje revelou uma tensão que eu sabia que existia mas não tratava?",
      "Em que momento fui mais honesto comigo do que com os outros?",
      "O que é que 'equipa' representou concretamente hoje?",
      "Em que situação fiz de conta que sabia quando não sabia?",
      "O que é que hoje me surpreendeu positivamente e o que isso diz sobre as minhas expectativas?",
      "Que conversa hoje foi sobre a superfície mas precisava de ir mais fundo?",
      "Em que momento estive mais presente para os outros do que para mim próprio?",
      "O que é que 'comprometimento' significou hoje em relação ao que prometi?",
      "Que decisão de hoje ainda estou a adiar mentalmente?",
      "Em que situação a minha intuição estava certa e não a ouvi?",
      "O que teria mudado se tivesse chegado à reunião mais devagar?",
      "Em que situação a diversidade de perspetivas ajudou e quando dificultou?",
      "O que é que 'clareza' significou para a minha equipa hoje?",
      "Que situação de hoje era mais complexa do que eu estava disposto a admitir?",
      "Em que momento de hoje me senti mais corajoso do que confortável?",
      "O que é que fiz de mais hoje que esgotou energia sem acrescentar valor?",
      "Que promessa implícita fiz hoje que preciso de cumprir amanhã?",
      "Em que situação o contexto mudou mas eu mantive a mesma abordagem?",
      "O que é que 'responsabilidade partilhada' se pareceu hoje na prática?",
      "Que conversa de hoje teria corrido melhor se eu tivesse chegado mais curioso?",
      "Em que momento de hoje agradeci genuinamente em vez de por educação?",
      "O que é que o ritmo do meu dia me disse sobre as minhas prioridades reais?",
      "Que situação de hoje revelou algo sobre o sistema e não sobre as pessoas?",
      "Em que momento fui seguidor quando devia ter sido líder?",
      "O que é que 'vulnerabilidade' custou e ganhou hoje?",
      "Que aprendizagem de hoje ainda não formalizei?",
      "Em que situação confundi estar alinhado com estar em conformidade?",
      "Que momento de hoje foi de leveza e o que isso me ensina?",
      "Em que situação a minha comunicação criou confusão que eu depois tive de resolver?",
      "O que é que 'liderança distribuída' se pareceu na prática hoje?",
      "Que crença sobre a minha equipa foi confirmada ou desafiada hoje?",
      "Em que momento de hoje atuei a partir de valores e não de regras?",
      "O que é que 'inovação' significou concretamente hoje, mesmo que pequena?",
      "Que situação de hoje exigia adaptação e eu resisti?",
      "Em que momento senti que a equipa estava genuinamente unida?",
      "Que pausa de hoje foi mais produtiva do que qualquer reunião?",
      "Em que situação resolvi um sintoma em vez de uma causa?",
      "O que é que 'integridade' se pareceu nas minhas ações de hoje?",
      "Que momento de hoje foi de aprendizagem coletiva?",
      "Em que situação estive mais focado no problema do que na pessoa?",
      "O que é que 'autonomia' significou para a minha equipa hoje?",
      "Que decisão de hoje ainda não tomei e porquê?",
      "Em que momento de hoje fui o melhor líder que consigo ser?",
      "O que não consigo parar de pensar do que aconteceu hoje?",
      "Que situação de hoje precisava de menos análise e mais ação?",
      "Em que momento de hoje assumi a responsabilidade em vez de apontar o dedo?",
      "O que é que 'ganhar' significou para a equipa hoje?",
      "Que momento de hoje foi de risco calculado e o que aprendi com ele?",
      "Em que situação de hoje o silêncio foi a resposta certa?",
      "O que é que uma perspetiva externa veria na minha equipa hoje que eu não vejo?",
      "Que conversa de hoje foi mais um monólogo do que um diálogo?",
      "Em que momento de hoje senti que estava a fazer a diferença certa?",
      "Que situação de hoje era sobre mim quando devia ser sobre eles?",
      "Em que momento de hoje fui mais treinador do que árbitro?",
      "O que é que a forma como geri o tempo hoje revelou sobre as minhas prioridades?",
      "Que momento de hoje foi de genuína colaboração e não apenas de coordenação?",
      "Em que situação de hoje a hierarquia prejudicou a conversa?",
      "O que é que 'confiança psicológica' se pareceu hoje no meu contexto?",
      "Que situação de hoje vai aparecer de forma diferente quando olhar para ela daqui a um ano?",
      "Em que momento de hoje fui um obstáculo sem me aperceber?",
      "O que aprendi hoje sobre as necessidades não ditas da minha equipa?",
      "Que momento de hoje foi de pensamento sistémico genuíno?",
      "Em que situação de hoje a minha experiência foi um ativo e quando foi uma limitação?",
      "O que é que 'agilidade' significou hoje em contexto real?",
      "Que suposição sobre o cliente mudou hoje?",
      "Em que momento de hoje fiz algo apenas porque era o que se esperava?",
      "O que é que 'ambiguidade' exigiu de mim hoje?",
      "Que momento de hoje foi de alinhamento real entre intenção e impacto?",
      "Em que situação de hoje a minha comunicação foi mais sobre gerir imagem do que sobre partilhar verdade?",
      "O que é que 'propósito' significou na prática do que fiz hoje?",
      "Que aprendizagem de hoje quero partilhar com alguém amanhã?",
      "Em que momento de hoje estive genuinamente presente?",
      "Que situação de hoje revelou uma zona cega minha?",
      "Em que momento de hoje a equipa foi mais inteligente do que eu?",
      "O que é que 'diversidade de pensamento' se pareceu hoje numa conversa?",
      "Que momento de hoje foi de liderança pelo exemplo?",
      "O que é que 'pressão' trouxe de melhor e de pior hoje?",
      "Que conversa de hoje ficou incompleta e precisa de continuar amanhã?",
      "Em que momento de hoje fui capaz de dizer não sei com total conforto?",
      "O que é que 'equidade' se pareceu nas minhas decisões de hoje?",
      "Que momento de hoje foi de humor genuíno que aligeirou o ambiente?",
      "Em que situação de hoje tive de escolher entre o que era fácil e o que era certo?",
      "Que suposição sobre mim próprio foi testada hoje?",
      "Em que momento de hoje me senti mais próximo de ser o líder que quero ser?",
      "O que é que o fim do dia me diz sobre onde começo amanhã?",
      "Que momento de hoje foi de impacto real mas silencioso?",
      "Em que situação de hoje gerei mais calor do que luz?",
      "O que é que 'excelência' significou para mim hoje, concretamente?",
      "Que decisão de hoje foi difícil por ser nova ou por ser repetida?",
      "Em que momento de hoje o contexto me moldou mais do que eu moldei o contexto?",
      "O que é que 'dar espaço' significou na prática hoje?",
      "Que situação de hoje revelou a diferença entre o que digo que valorizo e o que efetivamente valorizo?",
      "Em que momento de hoje a pergunta certa teria substituído dez respostas erradas?",
      "Que conversa de hoje teria corrido melhor com mais humor?",
      "Em que situação de hoje coloquei a agenda acima das pessoas?",
      "Que momento de hoje foi de genuíno reconhecimento dado ou recebido?",
      "Em que situação de hoje a minha perspetiva foi o problema?",
      "O que é que 'construir confiança' significou hoje numa relação específica?",
      "Que momento de hoje foi de clareza inesperada sobre algo que estava confuso?",
      "Em que situação de hoje atuei a partir de quem sou e não de quem me pedem que seja?",
      "O que é que 'coragem de liderança' exigiu de mim hoje?",
      "Que aprendizagem de hoje vai mudar a forma como faço algo específico amanhã?",
      "Em que momento de hoje a equipa se auto-organizou sem precisar de mim?",
      "O que é que 'escuta ativa' se pareceu hoje quando consegui praticá-la?",
      "Que situação de hoje era sobre confiança disfarçada de processo?",
      "Em que momento de hoje fui o líder certo para o momento certo?",
      "O que é que 'ownership' significou hoje para mim ou para a equipa?",
      "Que situação de hoje revelou o que a cultura da equipa realmente é?",
      "Em que momento de hoje tive de escolher entre conforto e crescimento?",
      "O que é que 'fazer menos para conseguir mais' significou hoje?",
      "Que conversa de hoje criou mais clareza do que eu esperava?",
      "Em que situação de hoje o que eu não disse foi mais poderoso do que o que disse?",
      "O que é que 'comprometer sem capitular' se pareceu hoje?",
      "Que momento de hoje foi de adaptação genuína em vez de resistência?",
      "Em que situação de hoje o processo me serviu e quando me limitou?",
      "O que é que 'criar condições para outros crescerem' significou na prática hoje?",
      "Que conversa difícil de hoje ficou por ter?",
      "Em que momento de hoje me senti a trabalhar na resistência em vez de com a resistência?",
      "O que é que 'fazer as perguntas certas' se pareceu hoje?",
      "Que momento de hoje foi de pensamento estratégico genuíno?",
      "Em que situação de hoje confiei quando tinha dúvidas?",
      "O que é que 'bem-estar da equipa' se pareceu nas decisões que tomei hoje?",
      "Em que situação de hoje a minha humildade foi um ativo?",
      "O que é que 'comprometimento' se diferencia de 'conformidade' nas ações de hoje?",
      "Que situação de hoje teria beneficiado de mais vozes e menos decisão única?",
      "Em que momento de hoje liderei a partir do futuro que quero criar?",
      "Que situação de hoje revelou o custo de adiar uma conversa difícil?",
      "O que é que 'gestão da atenção' significou hoje em comparação com gestão do tempo?",
      "Que conversa de hoje começou de uma forma e terminou de outra completamente diferente?",
      "Em que situação de hoje o meu papel foi de facilitador e não de especialista?",
      "O que é que 'inteligência coletiva' se pareceu hoje?",
      "Que momento de hoje foi de clareza sobre o que realmente importa?",
      "Em que situação de hoje fui honesto à custa de ser simpático?",
      "O que é que 'fazer bem as coisas certas' significou hoje concretamente?",
      "Que situação de hoje revelou algo sobre como funciono sob pressão?",
      "Em que momento de hoje criei condições para alguém brilhar?",
      "O que é que 'resistência à mudança' se pareceu hoje e de onde vinha?",
      "Que conversa de hoje ficou por ter por medo e não por falta de tempo?",
      "Em que situação de hoje o meu poder formal ajudou e quando foi um obstáculo?",
      "O que é que 'alinhar expectativas' significou hoje na prática?",
      "Que momento de hoje foi de aprendizagem pela falha?",
      "Em que situação de hoje a minha narrativa interna sobre o que acontecia estava errada?",
      "O que é que 'sentido de pertença' se pareceu hoje na equipa?",
      "Que momento de hoje foi de escolha consciente entre dois valores em tensão?",
      "Em que situação de hoje fui capaz de mudar de ideia com graça?",
      "O que é que 'ritmo sustentável' significou ou não significou hoje?",
      "Que suposição sobre o futuro guiou hoje as minhas decisões sem eu questionar?",
      "Em que momento de hoje o feedback que dei foi ao serviço de quem recebeu?",
      "O que é que 'segurança psicológica' se pareceu hoje num momento específico?",
      "Que situação de hoje precisava de uma abordagem sistémica que não tive?",
      "Em que momento de hoje o meu sentido de humor foi um ativo relacional?",
      "O que é que 'comunicar com impacto' significou hoje concretamente?",
      "Que momento de hoje foi de liderança sem título?",
      "Em que situação de hoje a minha equipa foi mais corajosa do que eu?",
      "O que é que 'aprender em público' custou e ganhou hoje?",
      "Que conversa de hoje foi sobre poder e não sobre o assunto discutido?",
      "Em que momento de hoje me senti genuinamente comprometido com o trabalho?",
      "O que é que 'criar contexto' se diferencia de 'dar instruções' nas minhas ações de hoje?",
      "Que situação de hoje era sobre o passado mas fingíamos ser sobre o futuro?",
      "Em que momento de hoje fui mais curioso sobre a perspetiva dos outros do que sobre a minha própria razão?",
      "O que é que 'legado' se pareceu hoje num micro-momento específico?",
      "Que decisão de hoje foi tomada com boas razões mas más consequências antecipadas?",
      "Em que situação de hoje o problema que resolvi não era o problema real?",
      "O que é que 'gestão de conflito' se pareceu hoje em contexto real?",
      "Que momento de hoje foi de conexão genuína com alguém da equipa?",
      "Em que situação de hoje a minha identidade profissional me limitou?",
      "O que é que 'trabalho significativo' se pareceu hoje para mim?",
      "Que situação de hoje vai aparecer de forma diferente quando olhar para ela daqui a uma semana?",
      "Em que momento de hoje a equipa aprendeu com um erro em vez de escondê-lo?",
      "O que é que 'clareza de propósito' trouxe ou fez falta hoje?",
      "Que conversa de hoje deixou as duas partes diferentes de como entraram?",
      "Em que situação de hoje a minha experiência me foi útil e quando me fechou?",
      "O que é que 'co-responsabilidade' significou hoje na prática?",
      "Que momento de hoje foi de pensamento de longo prazo num contexto de curto prazo?",
      "Em que situação de hoje coloquei os meus resultados à frente das pessoas?",
      "O que é que 'liderança consciente' se pareceu hoje nos meus comportamentos?",
      "Que situação de hoje vai mudar a forma como me aproximo de algo similar amanhã?",
      "Em que momento de hoje a complexidade me paralisou em vez de me motivar?",
      "O que é que 'fazer a coisa certa' custou hoje concretamente?",
      "Que momento de hoje foi de impacto positivo que não antecipei?",
      "Em que situação de hoje a minha liderança foi mais sobre ego do que sobre serviço?",
      "O que é que hoje me disse sobre o tipo de ambiente que estou a criar?",
      "Que momento de hoje, por mais pequeno que fosse, foi de liderança genuína?",
      "Em que situação de hoje o sistema me limitou e onde fui eu o sistema?",
      "O que é que 'co-criar' se pareceu hoje em comparação com 'decidir por'?",
      "Que suposição sobre esta organização guia o meu trabalho sem eu a ter escolhido conscientemente?",
      "Em que momento de hoje fiz o que era esperado em vez do que era necessário?",
      "O que é que o meu estilo de liderança hoje protegeu e o que é que limitou?",
      "Que conversa de hoje foi de alta qualidade e o que a tornou assim?",
      "Em que momento de hoje a minha presença foi um obstáculo para outros?",
      "O que é que 'aprender continuamente' significou nas minhas ações concretas de hoje?",
      "Que momento de hoje foi de pensamento divergente genuíno?",
      "Em que situação de hoje confundi feedback com julgamento?",
      "O que ficará desta versão de mim de hoje que é útil para a versão de amanhã?",
      "Que relação de trabalho hoje ficou mais forte por algo que fiz ou disse?",
      "Em que momento de hoje o cansaço tomou uma decisão por mim?",
      "O que é que 'liderar pelo exemplo' se pareceu hoje nos meus comportamentos mais simples?",
      "Se o meu eu daqui a dez anos pudesse ver como liderei hoje, o que diria?"
    ],
    icebreakers: [
      "Se a tua semana fosse um filme, que género seria?",
      "Qual é a coisa mais estranha que alguma vez aprendeste numa formação?",
      "Se pudesses trocar de papel com alguém nesta sala durante um dia, com quem trocavas?",
      "Qual foi o teu maior momento de 'não fazia a mínima ideia do que estava a fazer' profissional?",
      "Que superpoder tens que ninguém aqui sabe?",
      "Se o teu trabalho fosse um animal, que animal seria?",
      "Qual é a tua regra não escrita que toda a gente devia ter?",
      "Se pudesses eliminar um tipo de reunião da face da terra, qual seria?",
      "Qual é o conselho mais inútil que alguma vez te deram profissionalmente?",
      "Que hábito teu que toda a gente considera estranho tu consideras genial?",
      "Se tivesses de descrever o teu papel atual em três palavras honestas, e não as do LinkedIn, quais seriam?",
      "Qual foi a última vez que fizeste algo pela primeira vez?",
      "Que música ninguém esperaria que fosse o teu hino de trabalho?",
      "Se a tua equipa fosse um prato de comida, que prato seria?",
      "Qual é o teu superpoder secreto que nunca colocarias no currículo?",
      "Se pudesses automatizar uma parte do teu trabalho para sempre, o que escolhias?",
      "Qual foi o teu momento 'porque é que ninguém me avisou disto' na carreira?",
      "Se o teu estilo de liderança fosse um tipo de café, qual seria?",
      "Qual é o teu vício de produtividade que sabes que não é produtividade nenhuma?",
      "Que coisa absurda ainda fazes do jeito mais complicado possível?",
      "Qual é o livro que toda a gente recomenda mas tu nunca conseguiste acabar?",
      "Que palavras de gestão te fazem querer largar tudo e ir para o campo?",
      "Qual é o teu ritual bizarro que te prepara para o trabalho?",
      "Que talento escondido tens que surpreenderia as pessoas nesta sala?",
      "Se o teu trabalho tivesse uma banda sonora, qual seria a música de abertura?",
      "Qual foi o teu melhor acidente criativo profissional?",
      "Se fosses um tipo de reunião, que tipo serias?",
      "Que pergunta sobre ti próprio ainda não tens resposta?",
      "Se a tua semana fosse uma estação do ano, qual seria esta?",
      "Qual foi o projeto mais caótico em que trabalhaste e o que o tornava secretamente divertido?",
      "Que coisa pequena no trabalho te dá um prazer desproporcionado?",
      "Qual é o teu truque de reuniões que toda a gente devia conhecer?",
      "Se tivesses de escolher um personagem de série para facilitar esta sessão, quem seria?",
      "Que decisão profissional má acabou por ser a melhor que tomaste?",
      "Qual é a frase que ouves frequentemente no trabalho que te faz revirar os olhos?",
      "Se o teu humor de hoje fosse um boletim meteorológico, como seria?",
      "Que coisa da tua infância ainda influencia a forma como trabalhas?",
      "Qual foi o teu maior momento de improviso total que acabou por correr bem?",
      "Que pergunta nunca fazes mas sempre queres fazer em reuniões?",
      "Qual é o livro, podcast ou ideia que mudou genuinamente a tua forma de pensar?",
      "Se fosses um ingrediente numa receita de equipa, que ingrediente serias?",
      "Que regra da empresa nunca percebeste e nunca soubeste de onde veio?",
      "Se tivesses de abandonar metade das tuas responsabilidades hoje, qual metade escolhias?",
      "Qual é o teu maior arrependimento de 'porquê é que não disse isto mais cedo'?",
      "Que tipo de líder na ficção te inspira genuinamente?",
      "Se pudesses apagar uma tendência de gestão dos últimos vinte anos, qual seria?",
      "Que coisa da tua área profissional ainda te parece magia?",
      "Qual foi a última vez que disseste 'eu não sei' com total conforto?",
      "Se tivesses de montar uma equipa usando personagens de desenhos animados, com quem começavas?",
      "Que habilidade não técnica consideras o teu verdadeiro diferencial?",
      "Se o teu trabalho fosse um desporto, que desporto seria?",
      "Que coisa que parece óbvia para ti é completamente invisível para os outros?",
      "Qual foi o feedback mais estranho que alguma vez recebeste?",
      "Se pudesses ter uma segunda carreira paralela, qual seria?",
      "Que coisa no mundo das organizações ainda não consegues acreditar que é real?",
      "Qual é a tua definição pessoal de uma boa reunião?",
      "Se a tua empresa tivesse um mascote, que animal seria?",
      "Que coisa aprendeste fora do trabalho que aplicas mais dentro?",
      "Qual foi o teu maior 'pensei que sabia e afinal não sabia' profissional?",
      "Se fosses um tipo de post-it, que cor e conteúdo serias?",
      "Qual é o teu superpoder de recuperação de energia, o que fazes para te recarregar?",
      "Se a tua próxima reunião fosse um jogo de tabuleiro, que jogo seria?",
      "Que coisa no mundo corporativo devia ser muito mais simples?",
      "Qual é a coisa mais útil que alguma vez roubaste de outra área ou empresa?",
      "Se tivesses de criar um novo papel na tua equipa, como o chamarias e o que faria?",
      "Que coisa já fizeste no trabalho que nunca contaste a ninguém?",
      "Se pudesses fazer uma pergunta anónima à tua liderança, qual seria?",
      "Que coisa te deixa genuinamente entusiasmado mesmo quando está tudo caótico?",
      "Qual é a última coisa que aprendeste que te fez sentir um iniciante de novo?",
      "Se a tua carreira fosse um álbum de música, como chamavas ao álbum atual?",
      "Que mito sobre o teu papel já desmontaste mais vezes do que consegues contar?",
      "Qual é o teu indicador pessoal de 'hoje correu bem'?",
      "Se pudesses enviar uma mensagem ao teu eu de há dez anos, qual seria?",
      "Que coisa pequena do teu trabalho tem um impacto enorme que ninguém vê?",
      "Qual foi a última vez que uma ideia completamente absurda resultou mesmo?",
      "Se o teu processo de tomada de decisão fosse um prato de restaurante, era fast food ou fine dining?",
      "Que coisa do teu trabalho ainda te fascina depois de todos estes anos?",
      "Se tivesses de criar um ritual de equipa que toda a gente adorasse, o que seria?",
      "Qual é a tua maior contradição pessoal enquanto profissional?",
      "Se a tua intuição fosse um personagem, como seria a sua personalidade?",
      "Qual foi o teu momento mais criativo sob pressão?",
      "Se tivesses de resumir a tua abordagem ao trabalho numa frase de T-shirt, qual seria?",
      "Que coisa do trabalho remoto ainda preferes ao presencial?",
      "Qual é o teu ritual pré-voo antes de uma reunião importante?",
      "Se pudesses mudar um comportamento teu de forma instantânea, qual seria?",
      "Que coisa detestas admitir que sabes que funciona?",
      "Qual foi o momento em que mais te sentiste fora da tua zona de conforto e ficaste orgulhoso?",
      "Se o teu telefone pudesse falar sobre o teu dia de trabalho, o que diria?",
      "Que coisa na tua área está claramente a morrer mas ninguém quer admitir?",
      "Qual é o teu pior pesadelo de reunião que já se tornou realidade?",
      "Se tivesses de criar um glossário honesto do teu trabalho, que três termos incluirias?",
      "Que coisa que achas que és bom a fazer a tua equipa discordaria?",
      "Qual foi a última vez que alguém te surpreendeu completamente com uma ideia?",
      "Se pudesses tornar um valor da tua empresa completamente real amanhã, qual escolhias?",
      "Que coisa aprendeste por osmose sem nunca ter estudado formalmente?",
      "Qual é o teu maior conforto no caos?",
      "Se a tua equipa fosse uma constelação de estrelas, como se chamaria?",
      "Qual é o teu guilty pleasure profissional?",
      "Se pudesses ter uma hora extra todos os dias sem que ninguém soubesse, o que farias?",
      "Que coisa do teu trabalho não consegues explicar a um familiar sem que eles adormeçam?",
      "Qual foi a tua melhor aprendizagem que veio de um fracasso?",
      "Se o teu ego profissional tivesse um tamanho, seria grande como quê?",
      "Que coisa achas que toda a gente da empresa devia experimentar pelo menos uma vez?",
      "Qual é o maior paradoxo do teu trabalho?",
      "Se fosses recrutar para a tua própria personalidade, que advertência colocavas na oferta de emprego?",
      "Que coisa no trabalho ainda te faz sentir como um intruso?",
      "Qual foi o momento em que mais te sentiste genuinamente parte de uma equipa?",
      "Se pudesses redesenhar o onboarding da empresa a partir do zero, o que mudavas primeiro?",
      "Que coisa do teu trabalho seria completamente incompreensível para alguém de há cinquenta anos?",
      "Qual é o teu maior aliado no trabalho que não é uma pessoa?",
      "Se tivesses de explicar Agile a uma avó de oitenta e cinco anos, como o farias?",
      "Que coisa no trabalho te faz rir mesmo quando não devias?",
      "Qual foi o teu momento eureka profissional mais inesperado?",
      "Se o teu trabalho tivesse uma temperatura, qual seria hoje?",
      "Que coisa do passado profissional que achaste péssima agora vês como uma grande escola?",
      "Qual é a tua maior força que é também a tua maior fraqueza?",
      "Se tivesses de escolher um filme para descrever o ambiente atual da tua equipa, qual seria?",
      "Qual foi a última vez que te sentiste genuinamente surpreendido por algo de positivo no trabalho?",
      "Se pudesses eliminar uma palavra do vocabulário corporativo para sempre, qual seria?",
      "O que é que o teu eu de há cinco anos diria sobre o teu trabalho agora?",
      "Qual é o teu maior superpoder que custou mais a aceitar?",
      "Se tivesses de criar um código de conduta de equipa com apenas três regras, quais seriam?",
      "Que coisa já fizeste no trabalho que nunca incluirias no teu LinkedIn mas que te orgulha?",
      "Qual é a tua maior aprendizagem de liderança que não veio de um livro?",
      "Se o teu estilo de comunicação fosse um tipo de trânsito, qual seria?",
      "Que coisa no mundo dos negócios ainda não percebeste porquê existe mas continua a existir?",
      "Se pudesses criar um novo feriado para a empresa, o que celebraria?",
      "Que coisa do teu trabalho, se fizeres bem, passa completamente despercebida?",
      "Qual é o teu maior paradoxo enquanto membro de equipa?",
      "Se a tua semana fosse um género literário, seria romance, thriller ou ficção científica?",
      "Que coisa já aprendeste de alguém mais novo do que tu que te mudou a perspetiva?",
      "Qual foi o teu maior 'afinal não sou o único' numa conversa honesta?",
      "Se pudesses telefonar a qualquer líder do mundo durante dez minutos, a quem telefonavas?",
      "Que coisa pequena que fazes no trabalho tem um impacto que nunca reconheces?",
      "Qual é a tua versão favorita de ti próprio no trabalho e o que a cria?",
      "Se o teu processo criativo fosse um animal, que animal seria?",
      "Que coisa achas que é urgente mudar no mundo do trabalho nos próximos cinco anos?",
      "Qual foi o teu momento 'isto não foi o que aprendi na escola' mais impactante?",
      "Se pudesses redesenhar uma reunião semanal da tua vida, qual seria e como ficava?",
      "Que coisa que alguém disse sobre ti nunca te saiu da cabeça?",
      "Qual é a tua maior fonte de energia no trabalho que não é cafeína?",
      "Se o teu trabalho fosse um prato que cozinhaste, seria comida de conforto ou alta cozinha?",
      "Que coisa fascinante sobre o teu trabalho ainda não partilhaste com ninguém nesta sala?",
      "Qual foi o teu maior momento de 'sei que não é assim que se faz mas vou fazer na mesma'?",
      "Se tivesses de criar uma nova tradição de equipa, o que seria?",
      "Que coisa que o teu mentor te disse levou anos a entender?",
      "Qual é o teu ponto de viragem pessoal na carreira?",
      "Se o teu trabalho fosse um género musical, qual seria?",
      "Que coisa do trabalho em equipa ainda te espanta pela positiva?",
      "Se pudesses ser invisível durante uma hora no trabalho, onde é que ias?",
      "Que coisa descobriste sobre ti próprio que nunca terias descoberto sem este trabalho?",
      "Qual é a tua maior aversão profissional que toda a gente acha estranha?",
      "Se a tua equipa fosse um país, que país seria e porquê?",
      "Que coisa aprendeste por fazer ao contrário do que te disseram?",
      "Qual foi o teu maior 'descobri que sou capaz disto' nos últimos dois anos?",
      "Se tivesses de criar uma playlist para esta sessão, que música punhas primeiro?",
      "Que coisa no trabalho ainda não consegues fazer de forma consistente mas quiseras?",
      "Qual é a tua visão de sucesso que é completamente diferente do que pensavas há dez anos?",
      "Se o teu estilo de trabalho fosse um elemento da natureza, qual seria?",
      "Que coisa já aprendeste numa conferência que aplicaste mesmo no dia seguinte?",
      "Qual foi o teu maior 'levei mais tempo do que devia a perceber isto'?",
      "Se pudesses escolher uma habilidade para ter da noite para o dia, qual seria?",
      "Que coisa do trabalho colaborativo ainda te desafia genuinamente?",
      "Qual é o teu maior desafio atual que consegues resumir numa frase?",
      "Se o teu trabalho fosse um jogo de vídeo, em que nível estarias?",
      "Que coisa que parece séria no trabalho é fundamentalmente absurda quando paras para pensar?",
      "Qual foi o teu momento mais honesto com um colega de trabalho?",
      "Se fosses um tipo de liderança de um livro, que personagem serias?",
      "Que coisa ainda não chegaste a acordo contigo próprio sobre o teu trabalho?",
      "Qual é a tua maior fonte de inspiração que ninguém esperaria?",
      "Se pudesses mandar uma mensagem ao fundador da tua empresa, o que dirias?",
      "Que coisa que costumas adiar que quando fazes demora dez minutos?",
      "Qual foi o teu maior 'quem sou eu para estar aqui' e como o superaste?",
      "Que coisa do trabalho remoto mudou a tua visão sobre produtividade?",
      "Qual é o teu maior 'não se pode dizer isto mas toda a gente pensa'?",
      "Se o teu dia de trabalho ideal existisse, como começaria?",
      "Que coisa ainda te faz sentir um novato mesmo com toda a tua experiência?",
      "Qual foi o teu maior momento de 'precisava de ter pedido ajuda mais cedo'?",
      "Se o teu processo de aprendizagem fosse uma viagem, seria de autocarro ou de mochila às costas?",
      "Que coisa que dizes frequentemente achas que ninguém leva a sério?",
      "Qual é o teu maior segredo de produtividade que é ridiculamente simples?",
      "Se tivesses de criar um prémio para a tua equipa, como se chamaria o mais estranho?",
      "Que coisa que vês como uma fraqueza os outros veem como uma força?",
      "Qual foi o teu maior 'afinal era mais simples do que eu pensava'?",
      "Se pudesses ser pago para fazer algo que fazes de graça, o que seria?",
      "Qual é o teu maior talento que nunca colocas na ementa principal?",
      "Se a tua equipa fosse uma startup, que problema estaria a resolver?",
      "Que coisa que fazes por instinto levou outros anos a aprender?",
      "Qual foi o teu maior momento de 'isto vai correr mal' que correu bem?",
      "Se pudesses ter um coach pessoal permanente, o que lhe pedias primeiro?",
      "Que coisa já dizes às pessoas que não pões em prática tu próprio?",
      "Qual é a tua maior habilidade de sobrevivência no trabalho?",
      "Se o teu trabalho fosse um tipo de culinária, seria fusão, tradicional ou molecular?",
      "Que coisa aprenderias amanhã se pudesses escolher qualquer coisa?",
      "Se tivesses de criar um TED Talk sobre o teu trabalho, qual seria o título?",
      "Que coisa que ninguém nunca agradeceu e devia ter agradecido?",
      "Qual é o teu maior aliado invisível no trabalho?",
      "Que coisa de ti próprio ainda te surpreende no trabalho?",
      "Qual foi o teu maior momento de 'finalmente entendi' sobre trabalho em equipa?",
      "Se pudesses criar uma disciplina nova no ensino que preparasse para o mundo real, qual seria?",
      "Que coisa que parece caos para outros é perfeitamente organizada para ti?",
      "Qual é o teu maior talento que é também o teu maior risco?",
      "Se o teu estilo de aprendizagem fosse um veículo, qual seria?",
      "Que coisa que nunca aprendeste formalmente és agora um especialista?",
      "Qual foi a tua maior mudança de mindset nos últimos três anos?",
      "Se pudesses redesenhar completamente o teu papel atual, o que eliminavas primeiro?",
      "Que coisa no trabalho ainda acreditas mesmo que seja impopular?",
      "Qual é o teu maior 'não vou conseguir mas vou tentar na mesma'?",
      "Que coisa que aprendeste de um erro alheio te poupou muito?",
      "Qual foi o teu maior momento de liderança que não foi reconhecido e não precisava de ser?",
      "Se pudesses criar um papel novo na organização, como descrevias o impacto que teria?",
      "Que coisa que é vista como normal no trabalho ainda te parece completamente estranha?",
      "Qual é o teu maior 'aprendi mais aqui do que em qualquer formação'?",
      "Se a tua semana de trabalho fosse uma sequência de emojis, quais seriam os três de hoje?",
      "Que coisa que o teu eu de daqui a dez anos riria da tua preocupação atual?",
      "Qual foi o teu momento mais memorável de colaboração genuína?",
      "Se pudesses ter uma conversa honesta com alguém na tua empresa sem consequências, quem seria?",
      "Que coisa do teu trabalho que parece mundana é na verdade fascinante?",
      "Qual é o teu maior aliado inesperado na tua carreira?",
      "Se o teu trabalho fosse uma expedição, era de montanha ou de mar?",
      "Que coisa aprenderias sobre ti próprio se trabalhasses numa área completamente diferente?",
      "Se tivesses de escrever uma autobiografia profissional com um título honesto, qual seria?",
      "Que coisa ainda não fizeste no trabalho que um dia vais agradecer a ti próprio por ter feito?",
      "Qual é o teu maior 'não é o meu trabalho mas faço na mesma' que te define?",
      "Se a tua contribuição para esta equipa fosse um ingrediente secreto, qual seria?",
      "Que coisa do trabalho remoto nunca te voltou a adaptar ao presencial?",
      "Qual foi o teu maior momento de humor involuntário numa reunião importante?",
      "Se pudesses dar uma masterclass sobre uma coisa não técnica que dominares, qual seria?",
      "Que coisa ainda não tens coragem de dizer em voz alta numa reunião de liderança?",
      "Se o teu trabalho fosse uma frase de um livro, qual seria?",
      "Que coisa que hoje é regra na tua empresa começou como uma ideia maluca de alguém?",
      "Qual foi o teu maior 'levei a sério quando toda a gente achava que era piada'?",
      "Se pudesses adicionar um valor à cultura da tua empresa amanhã, qual seria?",
      "Que coisa no mundo do trabalho ainda acreditas que é possível mudar?",
      "Qual é o teu maior talento de facilitação informal que nunca chamaste pelo nome?",
      "Se o teu ambiente de trabalho ideal fosse uma obra de arte, que obra seria?",
      "Que coisa que sabes sobre ti próprio ainda não aceitaste completamente?",
      "Qual foi o teu maior 'foi difícil mas valeu' de liderança?",
      "Se tivesses de criar um manifesto para o teu trabalho em três linhas, o que diria?",
      "Que coisa do passado corporativo que foi enterrada devia ser ressuscitada?",
      "Qual é o teu maior segredo para manter a calma no caos?",
      "Se o teu trabalho fosse um capítulo de livro, qual seria o título do capítulo atual?",
      "Que coisa ainda tens de provar a ti próprio no trabalho?",
      "Qual foi o teu maior 'mudei de ideias completamente' sobre liderança?",
      "Se pudesses criar um ritual de abertura de reuniões que toda a gente adorasse, o que seria?",
      "Que coisa que fazes para te manter motivado seria impublicável num manual de recursos humanos?",
      "Qual é o teu maior 'este fracasso ensinou-me mais do que qualquer sucesso'?",
      "Que coisa que parece séria no trabalho é fundamentalmente divertida quando a vês bem?",
      "Qual foi o teu maior momento de 'será que estou no sítio certo' que foi seguido de uma certeza?",
      "Se pudesses criar um novo idioma para o trabalho, qual seria a primeira palavra nova?",
      "Que coisa na tua área que parece inovação é apenas uma coisa antiga com um nome novo?",
      "Qual é o teu maior 'fiz por intuição e depois aprendi que tinha um nome académico'?",
      "Se tivesses de resumir o teu impacto até hoje em três palavras honestas, quais seriam?",
      "Que coisa que dizes que valorizas ficaria provada nos teus comportamentos de hoje?",
      "Qual foi o teu maior 'acreditei mesmo quando mais ninguém acreditava'?",
      "Se o teu trabalho fosse uma lente fotográfica, seria grande angular ou telefoto?",
      "Que coisa ainda não partilhaste nesta sala que pode ser relevante para toda a gente?",
      "Qual é o teu maior 'é pequeno mas importa' no trabalho?",
      "Se pudesses mudar uma coisa na forma como os líderes são desenvolvidos, o que seria?",
      "Que coisa do trabalho em equipa achas que é fundamentalmente uma questão de confiança?",
      "Qual foi o teu maior momento de autenticidade que custou algo concreto?",
      "Que coisa que toda a gente faz nas empresas que ninguém consegue explicar porquê?",
      "Qual é o teu maior 'ainda não acabei de aprender isto'?",
      "Se o teu trabalho fosse um som, que som seria hoje?",
      "Que coisa sobre ti próprio descobriste através do trabalho que não descobririas de outra forma?",
      "Qual foi o teu maior 'não era sobre o trabalho, era sobre mim'?",
      "Se pudesses criar uma tradição de encerramento de ano para a tua equipa, o que seria?",
      "Que coisa sobre o futuro do trabalho ainda te entusiasma genuinamente?",
      "Se tivesses de escolher uma música para descrever o teu estado de espírito profissional agora, qual seria?",
      "Que coisa que já fizeste no trabalho teria ficado melhor se tivesses pedido ajuda?",
      "Qual foi o momento em que mais percebeste que as pessoas são o trabalho real?",
      "Se o teu cargo atual tivesse um subtítulo honesto, qual seria?",
      "Que coisa que disseste numa reunião ainda estás a tentar perceber porquê disseste?",
      "Qual é a tua maior crença sobre liderança que nunca fala em nenhum livro?",
      "Se pudesses redesenhar uma única reunião recorrente da tua vida, qual escolhias?",
      "Que coisa de ti próprio ainda não sabes se é uma força ou uma fraqueza?",
      "Qual foi o momento em que mais te sentiste genuinamente visto no trabalho?",
      "Se o teu trabalho fosse uma receita, qual seria o ingrediente que toda a gente esquece mas faz toda a diferença?",
      "Que coisa que aprendeste sobre ti mesmo num conflito que nunca aprenderias numa formação?",
      "Qual é o teu maior 'fiz a coisa certa mas da forma errada'?",
      "Se a cultura da tua empresa fosse um cheiro, qual seria?",
      "Que coisa no trabalho te dá uma satisfação que nunca consegues explicar completamente?",
      "Qual foi o teu maior momento de 'fui eu o problema e só percebi depois'?",
      "Se tivesses de criar um prémio para celebrar os erros mais úteis da equipa, como se chamaria?",
      "Que coisa ainda não tens resposta sobre a tua própria liderança?",
      "Qual é o teu maior 'ninguém sabe que faço isto mas é o que mantém tudo a funcionar'?",
      "Se o teu trabalho fosse uma conversa, seria de quê com quem?",
      "Que coisa aprendeste sobre ti próprio ao observar como os outros te observam?",
      "Qual foi o momento em que mais quiseste desistir e não desististe, e o que ficou?",
      "Se a tua equipa te descrevesse numa frase sem te consultar, o que achas que diria?",
      "Que coisa no trabalho ainda te surpreende pela negativa e não aceitas como inevitável?",
      "Qual é o teu maior 'comecei a fazer por obrigação e acabei a fazer por convicção'?",
      "Se pudesses fazer uma coisa diferente amanhã de manhã que mudaria o tom do teu dia, o que seria?",
      "Que coisa do trabalho que parece técnica é na verdade completamente humana?",
      "Qual foi o teu maior momento de 'o óbvio que não conseguia ver'?",
      "Se tivesses de descrever a tua relação com o trabalho como se fosse uma pessoa, como seria essa pessoa?",
      "Que coisa do teu percurso profissional nunca incluirias num CV mas define quem és?",
      "Qual é o teu maior 'aprendi a fazer isto ao contrário de como se supõe que se faz'?",
      "Se pudesses enviar um postal anónimo a alguém com quem trabalhaste, o que diria?",
      "Que coisa que ainda não fizeste no trabalho seria a mais importante de fazer nos próximos três meses?"
    ],
    checkin: [
      "Numa escala de bateria de telemóvel, a que percentagem estás agora?",
      "Que palavra descreve o teu estado de espírito neste momento?",
      "O que trouxeste contigo para esta sessão que não estava na convocatória?",
      "Que parte de ti está presente hoje e que parte ficou na porta?",
      "O que precisas de deixar fora desta sala para estar plenamente aqui?",
      "Se o teu estado atual fosse um boletim meteorológico, como seria?",
      "O que te deu energia esta semana?",
      "Que coisa te está a ocupar a mente que não é isto?",
      "Em que pé chegaste hoje?",
      "O que queres que saibamos antes de começarmos?",
      "Que expectativa tens desta sessão que é honesta e não polida?",
      "Numa palavra, como tens estado?",
      "O que deixou de ser urgente para ti esta semana?",
      "Que coisa boa aconteceu desde a última vez que nos vimos?",
      "O que está a funcionar bem no teu trabalho neste momento?",
      "Que desafio estás a enfrentar que não consegues parar de pensar?",
      "O que te surpreendeu positivamente esta semana?",
      "Que parte do trabalho atual te dá mais energia?",
      "O que te está a drenar mais esta semana?",
      "Que coisa pequena merecia mais reconhecimento do que recebeu?",
      "O que queres que aconteça nesta sessão que ainda não verbalizaste?",
      "Em que parte do trabalho sentes que estás a crescer mais agora?",
      "Que suposição sobre esta semana foi desafiada?",
      "O que mais te orgulha do teu trabalho recente?",
      "Que pergunta ainda não fizeste mas precisas de fazer?",
      "Como está o teu nível de confiança neste momento?",
      "O que trouxeste de positivo desta semana para partilhar?",
      "Que coisa gostarias que fosse diferente neste momento?",
      "Em que situação te sentiste mais como tu próprio esta semana?",
      "O que precisas desta equipa agora que ainda não pediste?",
      "Que coisa nova aprendeste sobre ti próprio esta semana?",
      "Como está a tua clareza sobre o que tens de fazer a seguir?",
      "O que te motivou genuinamente esta semana, mesmo que de forma pequena?",
      "O que te está a pedir mais de ti do que tens disponível?",
      "Que coisa desta semana foi melhor do que esperavas?",
      "O que precisas de nomear antes de começarmos?",
      "Como está a tua ligação com o propósito do trabalho que fazes?",
      "Que coisa ainda não resolvida está a ocupar espaço na tua cabeça?",
      "O que te deu prazer genuíno no trabalho esta semana?",
      "Numa frase, o que é que esta semana te ensinou?",
      "Que coisa gostarias de ter mais tempo para fazer?",
      "Como está a tua energia para o que vem a seguir?",
      "O que te tornou mais vulnerável esta semana?",
      "Que coisa pequena desta semana teve um impacto desproporcionalmente grande?",
      "O que te surpreendeu na equipa esta semana?",
      "Como está a tua confiança nas pessoas com quem trabalhas?",
      "Que momento desta semana gostaria de repetir?",
      "O que precisas de reconhecer sobre ti próprio antes de começarmos?",
      "Como é que o teu corpo está neste momento?",
      "Que conversa desta semana ainda está a trabalhar em ti?",
      "O que desta semana foi mais difícil do que antecipaste?",
      "Que coisa gostarias de ter feito diferente?",
      "Como está o teu nível de clareza sobre as prioridades?",
      "O que te está a pedir mais paciência do que tens?",
      "Que progresso, por mais pequeno que seja, aconteceu esta semana?",
      "O que está a funcionar bem que merece ser nomeado?",
      "Que coisa desta semana foi de aprendizagem coletiva?",
      "Como está a tua relação com a incerteza neste momento?",
      "O que precisas que a equipa saiba antes de começarmos?",
      "Que coisa ainda está por resolver e vai entrar nesta sala connosco?",
      "Como está a tua ligação com o que fazemos juntos?",
      "O que de bom aconteceu que ainda não celebraste?",
      "Que coisa desta semana foi inesperada e positiva?",
      "Como está o teu nível de foco neste momento?",
      "O que te está a distrair mais esta semana?",
      "Que aprendizagem desta semana ainda não formalizaste?",
      "Como está a tua sensação de controlo sobre o teu trabalho?",
      "O que te dá confiança neste momento?",
      "Que coisa desta semana te fez sentir mais parte da equipa?",
      "Como está a tua relação com o que tens de entregar?",
      "O que precisas de soltar antes de conseguires estar presente?",
      "Que momento desta semana foi de conexão genuína?",
      "Como está o teu humor de colaboração neste momento?",
      "O que está a correr bem que podemos aprender para replicar?",
      "Que coisa ainda não disseste sobre como estás que é relevante para o grupo?",
      "Como está a tua sensação de segurança para partilhar neste grupo?",
      "O que desta semana foi de liderança, formal ou informal?",
      "Que coisa ainda está por fazer que precisas de nomear?",
      "Como está a tua disposição para ser desafiado hoje?",
      "O que te dá esperança no trabalho neste momento?",
      "Que coisa desta semana foi de auto-gestão bem feita?",
      "Como está a tua ligação com os objetivos da equipa?",
      "O que ainda tens de processar desta semana que está a ocupar espaço?",
      "Que momento desta semana foi de feedback bem dado ou bem recebido?",
      "Como está a tua energia relacional com a equipa neste momento?",
      "O que desta semana foi mais difícil de comunicar?",
      "Que coisa gostarias de ter dito mais cedo?",
      "Como está a tua relação com a mudança neste momento?",
      "O que te fez sentir orgulhoso esta semana, por mais pequeno que fosse?",
      "Que coisa desta semana ainda está em aberto e precisas de nomear?",
      "Como está a tua capacidade de pedir ajuda neste momento?",
      "O que desta semana foi de tomada de decisão difícil?",
      "Que coisa de positivo queres trazer para esta sessão?",
      "Como está a tua sensação de pertença a esta equipa neste momento?",
      "O que desta semana foi de resiliência?",
      "Que coisa ainda não resolvida entre nós precisa de ser nomeada?",
      "Como está a tua energia para colaborar neste momento?",
      "O que te está a motivar mais neste projeto em concreto?",
      "Que coisa desta semana foi de risco tomado?",
      "Como é que estás, para além da resposta habitual?",
      "O que esta reunião vai interromper que também é importante?",
      "Que coisa desta semana foi um momento de clareza inesperada?",
      "Como está a tua disposição para ouvir perspetivas diferentes hoje?",
      "O que ainda não disseste à equipa que era altura de dizer?",
      "Que coisa desta semana foi de adaptação bem feita?",
      "Como está a tua ligação com o propósito desta sessão?",
      "O que te está a custar mais manter neste momento?",
      "Que aprendizagem desta semana veio de uma fonte inesperada?",
      "Como está a tua relação com a incerteza do projeto?",
      "O que desta semana foi de trabalho em equipa genuíno?",
      "Que coisa desta semana foi um sinal de que algo está a mudar?",
      "Como está a tua disposição para a conversa difícil, se for preciso?",
      "O que precisas de trazer para esta sessão que não é um slide?",
      "Que coisa de positivo desta semana ainda não reconheceste em voz alta?",
      "Como está a tua sensação de progresso em relação ao que é importante?",
      "O que gostarias que esta sessão resolvesse para ti?",
      "Que coisa desta semana foi de liderança pelo exemplo?",
      "Como está a tua relação com o tempo e as prioridades neste momento?",
      "O que te está a dar mais satisfação no trabalho agora?",
      "Que coisa desta semana revelou algo sobre a cultura da equipa?",
      "Como está a tua energia para o que precisamos de fazer juntos hoje?",
      "O que desta semana foi de conflito bem gerido?",
      "Que coisa ainda está em construção dentro de ti neste momento?",
      "Como está a tua disposição para ser honesto nesta sala hoje?",
      "O que desta semana foi de auto-conhecimento aplicado?",
      "Que coisa desta semana foi um momento de liderança sem título?",
      "Como está a tua relação com o feedback neste momento?",
      "O que te surpreendeu sobre ti próprio esta semana?",
      "Que coisa desta semana foi de genuína colaboração?",
      "Como está a tua disposição para colaborar com perspetivas diferentes?",
      "O que de bom ainda está por dizer sobre o trabalho da equipa?",
      "Que coisa desta semana foi de humildade bem vivida?",
      "Como está a tua sensação de clareza sobre o que queres fazer a seguir?",
      "O que desta semana foi de gestão do caos?",
      "Que coisa ainda precisas de processar antes de conseguires avançar?",
      "Como está a tua relação com o que ainda não sabes?",
      "O que gostarias de agradecer antes de começarmos?",
      "Que coisa desta semana foi de criatividade genuína?",
      "Como está a tua energia de contribuição para esta sessão?",
      "O que ainda tens de resolver antes do fim desta semana?",
      "Que momento desta semana foi de presença genuína?",
      "Como está a tua ligação com os valores que dizemos ter como equipa?",
      "O que desta semana foi de co-responsabilidade real?",
      "Que coisa desta semana foi mais sobre processo do que sobre pessoas?",
      "Como está a tua disposição para experimentar algo diferente hoje?",
      "O que te está a pesar mais neste momento?",
      "Que coisa desta semana foi de autonomia bem exercida?",
      "Como está a tua ligação com a visão do que queremos criar juntos?",
      "O que desta semana foi de gestão de expectativas?",
      "Que coisa desta semana ainda te está a surpreender?",
      "Como está a tua sensação de controlo versus caos neste momento?",
      "O que desta semana foi de pensamento estratégico em contexto tático?",
      "Que momento desta semana foi de troca genuína e não de transmissão?",
      "Como está a tua disposição para mudar algo que sabes que tem de mudar?",
      "O que desta semana foi de reação e o que foi de escolha consciente?",
      "Que coisa desta semana foi de alinhamento real entre intenção e impacto?",
      "Como está a tua energia de inovação neste momento?",
      "O que te está a dar mais incerteza neste projeto?",
      "Que coisa desta semana foi de reconhecimento genuíno?",
      "Como está a tua relação com o que não consegues controlar?",
      "O que desta semana foi de comunicação clara e eficaz?",
      "Que coisa de hoje foi um sinal de progresso por mais pequeno que fosse?",
      "Como está a tua disposição para criar espaço para outros hoje?",
      "O que desta semana precisava de mais atenção da tua parte?",
      "Que coisa desta semana foi de aprendizagem pela experiência?",
      "Como está a tua ligação com os objetivos desta sessão específica?",
      "O que te está a incomodar que ainda não nomeaste?",
      "Que coisa desta semana foi de gestão saudável de conflito?",
      "Como está a tua sensação de ritmo no trabalho neste momento?",
      "O que desta semana foi de respeito genuíno pelas diferenças?",
      "Que coisa desta semana foi uma surpresa sobre a equipa?",
      "Como está a tua capacidade de escuta neste momento?",
      "O que desta semana foi de tomada de decisão partilhada?",
      "Que coisa desta semana te fez sentir que a cultura da equipa está a melhorar?",
      "Como está a tua relação com o progresso desta sprint ou ciclo?",
      "O que desta semana foi de aprendizagem a partir de uma perspetiva diferente?",
      "Que coisa de hoje estás a trazer para aqui que não tem a ver com o trabalho mas vai influenciar o trabalho?",
      "Como está a tua disposição para ser influenciado hoje?",
      "O que te está a dar mais clareza esta semana?",
      "Que coisa desta semana foi de liderança partilhada?",
      "Como está a tua sensação de pertença neste contexto?",
      "O que desta semana foi de gestão de prioridades bem feita?",
      "Que coisa ainda não reconhecida desta semana merecia ser nomeada?",
      "Como está a tua energia para o que precisamos de decidir juntos?",
      "O que desta semana foi de confiança colocada noutra pessoa?",
      "Que coisa desta semana foi de coragem bem exercida?",
      "Como está a tua relação com o que é ambíguo neste momento?",
      "O que gostarias que esta equipa ficasse a saber sobre ti depois desta sessão?",
      "Que coisa desta semana foi de auto-confiança ganha?",
      "Como está a tua disposição para ir ao fundo das conversas hoje?",
      "O que desta semana foi de alinhamento entre o que pensas e o que fazes?",
      "Que coisa ainda está por dizer entre nós que precisamos de trazer para esta sala?",
      "Como está a tua sensação de segurança para discordar neste grupo?",
      "O que desta semana foi de gestão do stress de forma saudável?",
      "Que coisa desta semana foi de impacto não intencional que foi positivo?",
      "Como está a tua relação com os compromissos que fizeste?",
      "O que te está a dar mais satisfação no que entregas?",
      "Que coisa desta semana foi de pensamento sistémico aplicado?",
      "Como está a tua disposição para ser honesto sobre o que não sabes?",
      "O que desta semana foi de escuta antes de responder?",
      "Que coisa desta semana foi de liderança consciente?",
      "Como está a tua ligação com o trabalho que estás a fazer agora?",
      "O que gostarias de deixar aqui antes de começarmos?",
      "Que coisa desta semana foi de gestão da própria energia?",
      "Como está a tua disposição para explorar em vez de concluir hoje?",
      "O que desta semana foi de presença plena numa conversa?",
      "Que coisa de hoje está a ocupar espaço mental que precisas de nomear?",
      "Como está a tua sensação de fluxo no trabalho neste momento?",
      "O que desta semana foi de reconhecimento a outra pessoa?",
      "Que coisa desta semana foi de aprendizagem coletiva genuína?",
      "Como está a tua relação com os teus próprios limites neste momento?",
      "O que precisas de dizer antes que possas ouvir hoje?",
      "Que coisa desta semana foi de feedback bem dado sem ser pedido?",
      "Como está a tua disposição para co-criar em vez de apresentar?",
      "O que desta semana foi de clareza sobre o que importa mesmo?",
      "Que coisa ainda está por nomear no estado desta equipa?",
      "Como está a tua sensação de ritmo sustentável neste momento?",
      "O que te está a dar mais energia para continuar?",
      "Que coisa desta semana foi de adaptação genuína à mudança?",
      "Como está a tua disposição para criar em vez de criticar hoje?",
      "O que desta semana foi de conexão com o propósito maior do trabalho?",
      "Que coisa ainda precisas de resolver para te sentires presente aqui?",
      "Como está a tua relação com o que precisas de aprender?",
      "O que te está a pedir mais de ti do que achaste que tinha?",
      "Que coisa desta semana foi de co-responsabilidade bem vivida?",
      "Como está a tua ligação com o impacto do teu trabalho?",
      "O que de bom desta semana ainda não partilhaste?",
      "Que coisa desta semana foi de risco calculado e bem executado?",
      "Como está a tua disposição para ouvir o que não queres ouvir hoje?",
      "O que mais precisas desta sessão?",
      "Que coisa desta semana foi de respeito pela divergência?",
      "Como está a tua relação com o que ainda não sabes mas precisas de saber?",
      "O que desta semana foi de integridade aplicada?",
      "Que coisa de hoje ainda está a trabalhar em ti?",
      "Como está a tua disposição para pedir o que precisas?",
      "O que desta semana foi de coragem relacional?",
      "Que coisa desta semana foi um momento de auto-gestão bem feita?",
      "Como está a tua sensação de impacto no trabalho que fazes?",
      "O que te está a ajudar mais a manter o foco?",
      "Que coisa desta semana foi de comunicação não verbal que importou?",
      "Como está a tua disposição para ir ao que é difícil hoje?",
      "O que desta semana foi de generosidade no trabalho?",
      "Que coisa esta semana revelou sobre o que realmente aportas à equipa?",
      "Como está a tua relação com o que está fora do teu controlo?",
      "O que desta semana foi de criatividade aplicada a um problema real?",
      "Que coisa desta semana foi uma vitória silenciosa que merece ser nomeada?",
      "Como está a tua disposição para ser curioso em vez de conclusivo hoje?",
      "O que desta semana foi de gestão de tensões saudável?",
      "Que coisa de hoje precisava de começar diferente para correr melhor?",
      "Como está a tua disposição para contribuir em vez de apenas participar?",
      "O que desta semana foi de liderança pelo serviço?",
      "Que coisa desta semana revelou algo sobre as tuas próprias prioridades?",
      "Como está a tua sensação de congruência entre o que dizes e o que fazes?",
      "O que desta semana foi de decisão coletiva genuína?",
      "Que coisa ainda não resolvida entre tu e o trabalho precisa de espaço aqui?",
      "Como está a tua disposição para nomear o elefante na sala se aparecer?",
      "O que desta semana foi de progressão visível em algo que importa?",
      "Que coisa desta semana foi de auto-conhecimento aplicado?",
      "Como está a tua relação com o estado atual da equipa?",
      "O que de bom desta semana pode informar a forma como avançamos juntos?",
      "Que coisa ainda está em aberto entre nós que vai influenciar esta sessão?",
      "Como está a tua disposição para co-responsabilizar em vez de apontar?",
      "O que desta semana foi de resiliência coletiva?",
      "Que coisa de hoje ainda é incerteza que precisas de nomear?",
      "Como está a tua sensação de alinhamento com a direção da equipa?",
      "O que desta semana foi de presença com quem precisava?",
      "Que coisa desta semana foi de pensamento criativo aplicado?",
      "Como está a tua disposição para mudar de posição se a conversa pedir?",
      "O que te está a ajudar a ser melhor no trabalho neste momento?",
      "Que coisa desta semana foi de impacto positivo que não tinhas planeado?",
      "Como está a tua relação com as tuas próprias emoções no trabalho?",
      "O que desta semana foi de colaboração entre diferentes perspetivas?",
      "Que coisa ainda não disseste hoje que pode ser importante para o grupo?",
      "Como está a tua disposição para reconhecer o mérito dos outros hoje?",
      "O que desta semana foi de escuta genuína numa conversa difícil?",
      "Que coisa de hoje está a influenciar a forma como chegaste aqui?",
      "Como está a tua sensação de propósito no que estás a contribuir?",
      "O que desta semana foi de humildade intelectual?",
      "Que coisa ainda está por resolver na equipa que precisa de ser dita?",
      "Como está a tua energia de atenção neste momento?",
      "O que desta semana foi de agilidade mental bem exercida?",
      "Que coisa desta semana foi de feedback que mudou algo concreto?",
      "Como está a tua disposição para não ter as respostas hoje?",
      "O que te está a dar mais fé no trabalho desta equipa?",
      "Que coisa ainda não reconheceste sobre o que tens feito?",
      "Como está a tua ligação com as pessoas desta sala neste momento?",
      "O que desta semana foi de ritmo bem gerido?",
      "Que coisa desta semana foi de genuína curiosidade sobre outro ponto de vista?",
      "Como está a tua disposição para trazer o teu melhor hoje?",
      "O que desta semana foi de liderança sem necessidade de reconhecimento?",
      "Que coisa de bom ainda podes fazer antes de esta semana acabar?",
      "Como está a tua sensação de clareza sobre o que precisamos como equipa?",
      "O que desta semana foi de segurança psicológica bem criada?",
      "Que coisa ainda não nomeada desta semana precisa de ser vista?",
      "Como está a tua disposição para ouvir antes de resolver?",
      "O que te está a ensinar mais neste momento?",
      "Que coisa desta semana foi de conexão genuína com alguém?",
      "Como estás, com honestidade, neste exato momento?",
      "O que queres que fique desta sessão que não é um deliverable?",
      "Se esta equipa fosse uma conversa, de quê estaria a falar que ainda não está a falar?"
    ]
  },
  en: {
    daily: [
      "What did I learn today that I wasn't expecting to learn?",
      "In what moment today did I feel genuinely like myself?",
      "What did I avoid saying today, and why?",
      "What decision did I make today that I'd like to revisit tomorrow?",
      "Where did my ego get in the way of my work today?",
      "What would I have done differently if I'd known the outcome in advance?",
      "What conversation from today is still taking up space in my head?",
      "When did I lose the thread today, and what brought me back?",
      "What did I do today out of habit instead of conscious choice?",
      "What assumption of mine was challenged today?",
      "In what situation did I let myself be guided by what others expected of me?",
      "What did my body tell me today that my mind ignored?",
      "Who made me think differently today?",
      "Where did I need courage and didn't use it?",
      "What did 'done' mean to me today?",
      "In what moment of the day did I feel most alive?",
      "What problem today was really a symptom of something else?",
      "What did I delegate today when I should have done it myself?",
      "Which meeting today would have been better as an informal conversation?",
      "In what moment was I more of a leader than a manager?",
      "What did I do well today that I didn't acknowledge out loud?",
      "What negative pattern did I repeat today that I recognize from other days?",
      "Where did I confuse urgency with importance?",
      "What idea came up today that I haven't developed yet?",
      "In what situation did I behave differently from what my values suggest?",
      "What did someone's silence tell me today?",
      "What question was left unanswered at the end of the day?",
      "In what moment did I feel I was leading outward instead of inward?",
      "What would have happened if I'd said no earlier today?",
      "What vulnerability did I show today that cost me to show?",
      "Where did my attention go where it shouldn't have?",
      "What conversation today changed something, even subtly?",
      "In what moment did I feel part of something bigger than myself?",
      "What did 'progress' represent to me today?",
      "What untested assumption guided my decisions today?",
      "In what situation did I help when I should have let the person solve it alone?",
      "What moment from today would I like to preserve in a time capsule?",
      "What did my calendar today reveal about my real priorities?",
      "In what situation was I more honest than comfortable?",
      "What simple thing today had an impact I didn't anticipate?",
      "Where did my impatience cost me time?",
      "What story did I tell about myself today that may not be entirely true?",
      "In what moment was I more coach than boss?",
      "What did I hear today that I didn't want to hear but needed to?",
      "What small win today deserves more attention than I gave it?",
      "In what situation did I play it safe when I could have taken a risk?",
      "What did the feedback I received today tell me about myself?",
      "What assumption about my team did I prove wrong today?",
      "In what moment did I feel the environment was shaping me instead of me shaping it?",
      "What did 'leading' mean to me concretely today?",
      "What conflict did I ignore today that will show up tomorrow?",
      "In what situation did I ask a question when I should have given space?",
      "What does my energy at the end of the day tell me about how I should start tomorrow?",
      "Which of today's decisions was made with enough data, and which wasn't?",
      "In what moment did I lose the systemic perspective and get stuck in the detail?",
      "What difficult conversation did I postpone to tomorrow?",
      "In what situation was I more reactive than responsive?",
      "What is my tiredness telling me about what I need to change?",
      "Whose idea did I improve without giving them credit?",
      "In what moment today was I authentic without planning to be?",
      "What did 'accountability' mean in practice today?",
      "What thing today was outside my control and I spent energy trying to control?",
      "In what situation did my hierarchical position help, and when did it block?",
      "What did I not say out loud that communicated anyway?",
      "What situation today needed more perspective and less resolution?",
      "In what moment did I feel evaluated instead of supported?",
      "What would a ten-year-old say about what I did today?",
      "What team pattern did I observe today that tells me something about the culture?",
      "In what situation was I part of the problem and not part of the solution?",
      "What would I do differently if I knew nobody was watching?",
      "What moment from today will keep working on me while I sleep?",
      "In what situation did I put process before people?",
      "What did 'good enough' mean today, and where was it an excuse?",
      "What limiting belief did I activate today without realizing it?",
      "In what moment today did I feel genuinely curious instead of just polite?",
      "How did the way I started the day influence the rest of it?",
      "What situation today would have gone better with more silence from me?",
      "In what moment was I a mirror for someone without planning to be?",
      "What did my 'yes' today cost my 'no'?",
      "What conversation today opened something or closed something?",
      "In what situation did I confuse being busy with being productive?",
      "What did I miss the opportunity to thank today?",
      "What moment today was more about control than about trust?",
      "In what situation did my experience close me off instead of open me up?",
      "What did 'grow' mean to me today, specifically?",
      "What question didn't I ask today that could have changed the direction of the conversation?",
      "In what moment did I feel most aligned between what I think, say, and do?",
      "What do I systematically ignore that showed up again today?",
      "What decision did I make today that was driven by fear instead of vision?",
      "In what situation did I allow my insecurity to make decisions for me?",
      "What did I do today that only made sense to me?",
      "What learning today was uncomfortable and necessary at the same time?",
      "In what moment did my presence make a difference without me needing to say anything?",
      "What did 'culture' look like in my team today?",
      "In what situation did I let perfectionism block progress?",
      "What did 'trust' look like in action today?",
      "What moment of transition today went unnoticed?",
      "In what situation did I use data to hide a decision I'd already made?",
      "What did today teach me about the kind of leader I want to be?",
      "What unintentional impact did I have on a person or situation today?",
      "In what moment did I feel I was doing the wrong work in the right way?",
      "What did my body language say today that words didn't?",
      "What situation today revealed a tension I knew existed but wasn't addressing?",
      "In what moment was I more honest with myself than with others?",
      "What did 'team' represent concretely today?",
      "In what situation today did I pretend to know when I didn't?",
      "What surprised me positively today, and what does that say about my expectations?",
      "What conversation today was on the surface when it needed to go deeper?",
      "In what moment was I more present for others than for myself?",
      "What did 'commitment' mean today in relation to what I promised?",
      "Which decision from today am I still mentally postponing?",
      "In what situation was my intuition right and I didn't listen to it?",
      "What would have changed if I'd come to the meeting more slowly?",
      "In what situation did the diversity of perspectives help, and when did it complicate things?",
      "What did 'clarity' mean for my team today?",
      "What situation today was more complex than I was willing to admit?",
      "In what moment today was I more courageous than comfortable?",
      "What did I do too much of today that drained energy without adding value?",
      "What implicit promise did I make today that I need to keep tomorrow?",
      "In what situation did the context change but I kept the same approach?",
      "What did 'shared accountability' look like in practice today?",
      "What conversation today would have gone better if I'd arrived more curious?",
      "In what moment today did I thank someone genuinely instead of out of politeness?",
      "What did the rhythm of my day tell me about my real priorities?",
      "What situation today revealed something about the system and not the people?",
      "In what moment was I a follower when I should have been a leader?",
      "What did 'vulnerability' cost and gain today?",
      "What learning from today have I not yet formalized?",
      "In what situation did I confuse being aligned with being compliant?",
      "What moment of levity today, and what does it teach me?",
      "In what situation did my communication create confusion that I then had to resolve?",
      "What did 'distributed leadership' look like in practice today?",
      "What belief about my team was confirmed or challenged today?",
      "In what moment today did I act from values and not from rules?",
      "What did 'innovation' mean concretely today, even if small?",
      "What situation today required adaptation and I resisted?",
      "In what moment did I feel the team was genuinely united?",
      "What pause today was more productive than any meeting?",
      "In what situation did I solve a symptom instead of a cause?",
      "What did 'integrity' look like in my actions today?",
      "What moment today was one of collective learning?",
      "In what situation was I more focused on the problem than the person?",
      "What did 'autonomy' mean for my team today?",
      "What decision from today have I still not made, and why?",
      "In what moment today was I the best leader I can be?",
      "What from today can I not stop thinking about?",
      "What situation today needed less analysis and more action?",
      "In what moment today did I take responsibility instead of pointing fingers?",
      "What did 'winning' mean for the team today?",
      "What moment today was of calculated risk, and what did I learn from it?",
      "In what situation today was silence the right answer?",
      "What would an outside perspective see in my team today that I don't?",
      "What conversation today was more a monologue than a dialogue?",
      "In what moment today did I feel I was making the right difference?",
      "What situation today was about me when it should have been about them?",
      "In what moment today was I more coach than referee?",
      "What did how I managed my time today reveal about my priorities?",
      "What moment today was of genuine collaboration and not just coordination?",
      "In what situation today did the hierarchy damage the conversation?",
      "What did 'psychological safety' look like in my context today?",
      "What situation today will look different when I look back at it in a year?",
      "In what moment today was I an obstacle without realizing it?",
      "What did I learn today about my team's unspoken needs?",
      "What moment today was of genuine systems thinking?",
      "In what situation today was my experience an asset, and when was it a limitation?",
      "What did 'agility' mean today in a real context?",
      "What assumption about the client changed today?",
      "In what moment today did I do something just because it was expected?",
      "What did 'ambiguity' demand from me today?",
      "What moment today was of real alignment between intention and impact?",
      "In what situation was my communication more about managing image than sharing truth?",
      "What did 'purpose' mean in the practice of what I did today?",
      "What learning from today do I want to share with someone tomorrow?",
      "In what moment today was I genuinely present?",
      "What situation today revealed a blind spot of mine?",
      "In what moment today was the team smarter than me?",
      "What did 'diversity of thought' look like in a conversation today?",
      "What moment today was of leading by example?",
      "What did 'pressure' bring out best and worst in me today?",
      "What conversation today was left incomplete and needs to continue tomorrow?",
      "In what moment today was I able to say 'I don't know' with total comfort?",
      "What did 'equity' look like in my decisions today?",
      "What moment of genuine humor today lightened the atmosphere?",
      "In what situation today did I have to choose between what was easy and what was right?",
      "What assumption about myself was tested today?",
      "In what moment today did I feel closest to being the leader I want to be?",
      "What does the end of the day tell me about where I start tomorrow?",
      "What moment today was of real but silent impact?",
      "In what situation today did I generate more heat than light?",
      "What did 'excellence' mean to me today, concretely?",
      "Was today's difficult decision difficult because it was new or because it was repeated?",
      "In what moment today did context shape me more than I shaped it?",
      "What did 'giving space' mean in practice today?",
      "What situation today revealed the gap between what I say I value and what I actually value?",
      "In what moment today would the right question have replaced ten wrong answers?",
      "What conversation today would have gone better with more humor?",
      "In what situation today did I put the agenda above the people?",
      "What moment today was of genuine recognition given or received?",
      "In what situation today was my perspective the problem?",
      "What did 'building trust' mean today in a specific relationship?",
      "What moment today brought unexpected clarity to something that was confused?",
      "In what situation today did I act from who I am rather than who I'm asked to be?",
      "What did 'leadership courage' demand from me today?",
      "What learning from today will change how I do something specific tomorrow?",
      "In what moment today did the team self-organize without needing me?",
      "What did 'active listening' look like today when I managed to practice it?",
      "What situation today was about trust disguised as process?",
      "In what moment today was I the right leader for the right moment?",
      "What did 'ownership' mean today for me or for the team?",
      "What situation today revealed what the team culture really is?",
      "In what moment today did I have to choose between comfort and growth?",
      "What did 'doing less to achieve more' mean today?",
      "What conversation today created more clarity than I expected?",
      "In what situation today was what I didn't say more powerful than what I said?",
      "What did 'compromising without capitulating' look like today?",
      "What moment today was of genuine adaptation rather than resistance?",
      "In what situation today did process serve me, and when did it limit me?",
      "What did 'creating conditions for others to grow' mean in practice today?",
      "What difficult conversation today was left unfinished?",
      "In what moment today did I feel I was working against the resistance instead of with it?",
      "What did 'asking the right questions' look like today?",
      "What moment today was of genuine strategic thinking?",
      "In what situation today did I trust when I had doubts?",
      "What did 'team wellbeing' look like in the decisions I made today?",
      "In what situation today was my humility an asset?",
      "How did 'commitment' differ from 'compliance' in my actions today?",
      "What situation today would have benefited from more voices and less sole decision?",
      "In what moment today did I lead from the future I want to create?",
      "What situation today revealed the cost of postponing a difficult conversation?",
      "What did 'attention management' mean today compared to time management?",
      "What conversation today started one way and ended in a completely different place?",
      "In what situation today was my role that of facilitator and not expert?",
      "What did 'collective intelligence' look like today?",
      "What moment today was of clarity about what really matters?",
      "In what situation today was I honest at the cost of being nice?",
      "What did 'doing the right things well' mean today concretely?",
      "What situation today revealed something about how I function under pressure?",
      "In what moment today did I create conditions for someone to shine?",
      "What did 'resistance to change' look like today and where was it coming from?",
      "What difficult conversation today was left unfinished because of fear, not lack of time?",
      "In what situation today did my formal power help, and when was it an obstacle?",
      "What did 'aligning expectations' mean in practice today?",
      "What moment today was one of learning from failure?",
      "In what situation today was my internal narrative about what was happening wrong?",
      "What did 'sense of belonging' look like in the team today?",
      "What moment today was of conscious choice between two values in tension?",
      "In what situation today was I able to change my mind with grace?",
      "What did 'sustainable pace' mean or not mean today?",
      "What assumption about the future guided my decisions today without me questioning it?",
      "In what moment today was the feedback I gave in service of the person receiving it?",
      "What did 'psychological safety' look like in a specific moment today?",
      "What situation today needed a systemic approach I didn't have?",
      "In what moment today was my sense of humor a relational asset?",
      "What did 'communicating with impact' mean concretely today?",
      "What moment today was of leadership without a title?",
      "In what situation today was my team more courageous than me?",
      "What did 'learning in public' cost and gain today?",
      "What conversation today was about power and not about the topic being discussed?",
      "In what moment today did I feel genuinely committed to the work?",
      "How did 'creating context' differ from 'giving instructions' in my actions today?",
      "What situation today was about the past but we were pretending it was about the future?",
      "In what moment today was I more curious about others' perspectives than about proving my own?",
      "What did 'legacy' look like in a specific micro-moment today?",
      "What decision today was made with good reasons but poorly anticipated consequences?",
      "In what situation today was the problem I solved not the real problem?",
      "What did 'conflict management' look like in a real context today?",
      "What moment today was of genuine connection with someone on the team?",
      "In what situation today did my professional identity limit me?",
      "What did 'meaningful work' look like for me today?",
      "What situation today will look different when I look back at it in a week?",
      "In what moment today did the team learn from a mistake instead of hiding it?",
      "What did 'clarity of purpose' bring or lack today?",
      "What conversation today left both parties different from how they entered?",
      "In what situation today was my experience useful, and when did it close me off?",
      "What did 'co-accountability' mean in practice today?",
      "What moment today was of long-term thinking in a short-term context?",
      "In what situation today did I put my results ahead of people?",
      "What did 'conscious leadership' look like in my behaviors today?",
      "What situation today will change how I approach something similar tomorrow?",
      "In what moment today did complexity paralyze me instead of motivate me?",
      "What did 'doing the right thing' cost concretely today?",
      "What moment today was of positive impact I didn't anticipate?",
      "In what situation today was my leadership more about ego than service?",
      "What did today tell me about the type of environment I'm creating?",
      "What moment today, however small, was of genuine leadership?",
      "In what situation today was the system limiting me, and where was I the system?",
      "How did 'co-creating' differ from 'deciding for' in my actions today?",
      "What assumption about this organization guides my work without me having consciously chosen it?",
      "In what moment today did I do what was expected instead of what was necessary?",
      "What did my leadership style today protect, and what did it limit?",
      "What conversation today was of high quality, and what made it that way?",
      "In what moment today was my presence an obstacle for others?",
      "What did 'continuous learning' mean in my concrete actions today?",
      "What moment today was of genuine divergent thinking?",
      "In what situation today did I confuse feedback with judgment?",
      "What from today's version of me is useful for tomorrow's version?",
      "What working relationship today became stronger because of something I did or said?",
      "In what moment today did fatigue make a decision for me?",
      "What did 'leading by example' look like in my simplest behaviors today?",
      "If my self ten years from now could see how I led today, what would they say?"
    ],
    icebreakers: [
      "If your week were a movie, what genre would it be?",
      "What's the strangest thing you ever learned at a training?",
      "If you could swap roles with someone in this room for a day, who would it be?",
      "What was your biggest 'I had absolutely no idea what I was doing' professional moment?",
      "What superpower do you have that nobody in this room knows about?",
      "If your job were an animal, what animal would it be?",
      "What's your unwritten rule that everyone should have?",
      "If you could eliminate one type of meeting from the face of the earth, which would it be?",
      "What's the most useless piece of advice you've ever been given professionally?",
      "What habit of yours does everyone find strange but you consider genius?",
      "If you had to describe your current role in three honest words, not LinkedIn words, what would they be?",
      "When was the last time you did something for the first time?",
      "What song would no one expect to be your work anthem?",
      "If your team were a dish of food, what dish would it be?",
      "What's your secret superpower that you'd never put on a CV?",
      "If you could automate one part of your work forever, what would you choose?",
      "What was your biggest 'why did nobody warn me about this' moment in your career?",
      "If your leadership style were a type of coffee, which would it be?",
      "What's your productivity vice that you know isn't productive at all?",
      "What absurd thing do you still do in the most complicated way possible?",
      "What's the book everyone recommends but you've never managed to finish?",
      "What management words make you want to quit everything and go live in the countryside?",
      "What's your bizarre ritual that prepares you for work?",
      "What hidden talent do you have that would surprise the people in this room?",
      "If your work had a soundtrack, what would be the opening song?",
      "What was your best professional creative accident?",
      "If you were a type of meeting, what type would you be?",
      "What question about yourself do you still don't have the answer to?",
      "If this week were a season of the year, which one would it be?",
      "What was the most chaotic project you worked on and what made it secretly fun?",
      "What small thing at work gives you disproportionate pleasure?",
      "What's your meeting trick that everyone should know?",
      "If you had to choose a TV character to facilitate this session, who would it be?",
      "What bad professional decision turned out to be the best you ever made?",
      "What phrase do you hear frequently at work that makes you roll your eyes?",
      "If your mood today were a weather forecast, how would it read?",
      "What from your childhood still influences the way you work?",
      "What was your biggest 'total improvisation that ended up working' moment?",
      "What question do you never ask but always want to ask in meetings?",
      "What book, podcast, or idea genuinely changed how you think?",
      "If you were an ingredient in a team recipe, what ingredient would you be?",
      "What company rule have you never understood and never knew where it came from?",
      "If you had to drop half your responsibilities today, which half would you choose?",
      "What's your biggest 'why didn't I say this sooner' regret?",
      "What type of leader in fiction genuinely inspires you?",
      "If you could erase one management trend from the last twenty years, which would it be?",
      "What thing in your professional area still feels like magic to you?",
      "When was the last time you said 'I don't know' with total comfort?",
      "If you had to build a team using cartoon characters, who would you start with?",
      "What non-technical skill do you consider your true differentiator?",
      "If your job were a sport, what sport would it be?",
      "What seems obvious to you that is completely invisible to others?",
      "What's the strangest feedback you've ever received?",
      "If you could have a parallel second career, what would it be?",
      "What thing in the world of organizations do you still can't believe is real?",
      "What's your personal definition of a good meeting?",
      "If your company had a mascot, what animal would it be?",
      "What thing you learned outside work do you apply more inside?",
      "What was your biggest 'I thought I knew and I didn't' professional moment?",
      "If you were a type of post-it, what color and content would you be?",
      "What's your energy recovery superpower, what do you do to recharge?",
      "If your next meeting were a board game, what game would it be?",
      "What in the corporate world should be much simpler?",
      "What's the most useful thing you ever borrowed from another area or company?",
      "If you had to create a new role in your team, what would you call it and what would it do?",
      "What's something you did at work that you've never told anyone?",
      "If you could ask your leadership an anonymous question, what would it be?",
      "What keeps you genuinely excited even when everything is chaotic?",
      "What's the last thing you learned that made you feel like a beginner again?",
      "If your career were a music album, what would you call the current album?",
      "What myth about your role have you debunked more times than you can count?",
      "What's your personal indicator that 'today went well'?",
      "If you could send a message to your ten-years-ago self, what would it say?",
      "What small thing about your work has an enormous impact that nobody sees?",
      "When was the last time a completely absurd idea actually worked?",
      "If your decision-making process were a restaurant dish, would it be fast food or fine dining?",
      "What about your work still fascinates you after all these years?",
      "If you had to create a team ritual that everyone would love, what would it be?",
      "What's your biggest personal contradiction as a professional?",
      "If your intuition were a character, what would its personality be like?",
      "What was your most creative moment under pressure?",
      "If you had to summarize your approach to work in a T-shirt slogan, what would it be?",
      "What from remote work do you still prefer over in-person?",
      "What's your pre-flight ritual before an important meeting?",
      "If you could change one behavior of yours instantly, which would it be?",
      "What do you hate admitting you know works?",
      "When was the moment you felt most outside your comfort zone and were proud of it?",
      "If your phone could talk about your workday, what would it say?",
      "What in your field is clearly dying but nobody wants to admit it?",
      "What's your worst meeting nightmare that already became reality?",
      "If you had to create an honest glossary for your work, what three terms would you include?",
      "What thing you think you're good at would your team disagree with?",
      "When was the last time someone completely surprised you with an idea?",
      "If you could make one company value completely real tomorrow, which would you choose?",
      "What have you learned by osmosis without ever formally studying it?",
      "What's your greatest comfort in the chaos?",
      "If your team were a constellation of stars, what would it be called?",
      "What's your professional guilty pleasure?",
      "If you could have an extra hour every day without anyone knowing, what would you do?",
      "What about your job can't you explain to a family member without them falling asleep?",
      "What was your best learning that came from a failure?",
      "If your professional ego had a size, it would be as big as what?",
      "What do you think everyone in the company should experience at least once?",
      "What's the biggest paradox of your work?",
      "If you were recruiting for your own personality, what warning would you put in the job posting?",
      "What about work still makes you feel like an imposter?",
      "What was the moment when you felt most genuinely part of a team?",
      "If you could redesign the company onboarding from scratch, what would you change first?",
      "What about your work would be completely incomprehensible to someone from fifty years ago?",
      "What's your greatest work ally that isn't a person?",
      "If you had to explain Agile to an eighty-five-year-old grandmother, how would you do it?",
      "What at work makes you laugh even when you shouldn't?",
      "What was your most unexpected professional eureka moment?",
      "If your work had a temperature, what would it be today?",
      "What from your professional past that you found terrible do you now see as a great school?",
      "What's your greatest strength that is also your greatest weakness?",
      "If you had to choose a movie to describe your team's current atmosphere, which would it be?",
      "When was the last time you were genuinely surprised by something positive at work?",
      "If you could eliminate one word from corporate vocabulary forever, which would it be?",
      "What would your five-years-ago self say about your work now?",
      "What's your greatest superpower that took the longest to accept?",
      "If you had to create a team code of conduct with only three rules, what would they be?",
      "What have you done at work that you'd never put on LinkedIn but are proud of?",
      "What's your greatest leadership learning that didn't come from a book?",
      "If your communication style were a type of traffic, which would it be?",
      "What in the business world do you still not understand why it exists but it keeps existing?",
      "If you could create a new company holiday, what would it celebrate?",
      "What aspect of your work, if done well, goes completely unnoticed?",
      "What's your biggest paradox as a team member?",
      "If this week were a literary genre, would it be romance, thriller, or science fiction?",
      "What have you learned from someone younger than you that shifted your perspective?",
      "What was your biggest 'turns out I'm not the only one' in an honest conversation?",
      "If you could call any leader in the world for ten minutes, who would you call?",
      "What small thing you do at work has an impact you never acknowledge?",
      "What's your favorite version of yourself at work and what creates it?",
      "If your creative process were an animal, what animal would it be?",
      "What do you think is urgent to change in the world of work in the next five years?",
      "What was your most impactful 'this wasn't what I learned in school' moment?",
      "If you could redesign one weekly meeting in your life, which would it be and how would it look?",
      "What has someone said about you that you've never been able to forget?",
      "What's your greatest source of energy at work that isn't caffeine?",
      "If your work were a dish you cooked, would it be comfort food or haute cuisine?",
      "What fascinating thing about your work haven't you shared with anyone in this room?",
      "What was your biggest 'I know this isn't how it's done but I'm doing it anyway' moment?",
      "If you had to create a new team tradition, what would it be?",
      "What thing your mentor told you took years to understand?",
      "What's your personal turning point in your career?",
      "If your work were a musical genre, what would it be?",
      "What about teamwork still amazes you in a positive way?",
      "If you could be invisible for an hour at work, where would you go?",
      "What have you discovered about yourself that you never would have without this work?",
      "What's your greatest professional aversion that everyone finds strange?",
      "If your team were a country, which country would it be and why?",
      "What have you learned by doing the opposite of what you were told?",
      "What was your biggest 'I discovered I'm capable of this' in the last two years?",
      "If you had to create a playlist for this session, what song would you put first?",
      "What at work can you still not do consistently but wish you could?",
      "What's your vision of success that is completely different from what you thought ten years ago?",
      "If your work style were an element of nature, which would it be?",
      "What have you learned at a conference that you actually applied the next day?",
      "What was your biggest 'it took me longer than it should to understand this'?",
      "If you could choose one skill to have overnight, which would it be?",
      "What about collaborative work still genuinely challenges you?",
      "What's your biggest current challenge that you can summarize in one sentence?",
      "If your work were a video game, what level would you be on?",
      "What seems serious at work but is fundamentally absurd when you think about it?",
      "What was your most honest moment with a work colleague?",
      "If you were a type of leadership from a book, which character would you be?",
      "What haven't you come to an agreement with yourself about regarding your work?",
      "What's your greatest source of inspiration that nobody would expect?",
      "If you could send a message to your company's founder, what would you say?",
      "What do you usually put off that takes ten minutes when you actually do it?",
      "What was your biggest 'who am I to be here' moment and how did you overcome it?",
      "What from remote work changed your view on productivity?",
      "What's your biggest 'you can't say this but everyone thinks it'?",
      "If your ideal workday existed, how would it start?",
      "What still makes you feel like a newcomer even with all your experience?",
      "What was your biggest 'I needed to ask for help earlier' moment?",
      "If your learning process were a trip, would it be by bus or backpacking?",
      "What do you frequently say that you think nobody takes seriously?",
      "What's your greatest productivity secret that is ridiculously simple?",
      "If you had to create an award for your team, what would the strangest one be called?",
      "What do you see as a weakness that others see as a strength?",
      "What was your biggest 'turns out it was simpler than I thought'?",
      "If you could be paid to do something you do for free, what would it be?",
      "What's your greatest talent that never makes the main menu?",
      "If your team were a startup, what problem would it be solving?",
      "What do you do by instinct that took others years to learn?",
      "What was your biggest 'this is going to go wrong' moment that went right?",
      "If you could have a permanent personal coach, what would you ask them first?",
      "What do you tell people that you don't practice yourself?",
      "What's your greatest survival skill at work?",
      "If your work were a type of cuisine, would it be fusion, traditional, or molecular?",
      "What would you learn tomorrow if you could choose anything?",
      "If you had to create a TED Talk about your work, what would the title be?",
      "What has nobody ever thanked you for that they should have?",
      "What's your greatest invisible ally at work?",
      "What still surprises you about yourself at work?",
      "What was your biggest 'I finally understood' about teamwork?",
      "If you could create a new subject in education to prepare for the real world, what would it be?",
      "What seems like chaos to others but is perfectly organized to you?",
      "What's your greatest talent that is also your greatest risk?",
      "If your learning style were a vehicle, which would it be?",
      "What have you never formally studied but are now an expert in?",
      "What was your biggest mindset shift in the last three years?",
      "If you could completely redesign your current role, what would you eliminate first?",
      "What do you still believe about work even though it's unpopular?",
      "What's your biggest 'I'm not going to manage it but I'll try anyway'?",
      "What have you learned from someone else's mistake that saved you a lot?",
      "What was your biggest unrecognized leadership moment that didn't need to be recognized?",
      "If you could create a new role in the organization, how would you describe its impact?",
      "What is seen as normal at work that still seems completely strange to you?",
      "What's your biggest 'I learned more here than at any training'?",
      "If this work week were a sequence of emojis, what would today's three be?",
      "What would your ten-years-from-now self laugh at about your current worry?",
      "What was your most memorable moment of genuine collaboration?",
      "If you could have an honest conversation with someone in your company without consequences, who would it be?",
      "What about your work that seems mundane is actually fascinating?",
      "What's your greatest unexpected career ally?",
      "If your work were an expedition, would it be mountain or sea?",
      "What would you learn about yourself if you worked in a completely different area?",
      "If you had to write a professional autobiography with an honest title, what would it be?",
      "What haven't you done at work yet that you'll one day thank yourself for doing?",
      "What's your biggest 'it's not my job but I do it anyway' that defines you?",
      "If your contribution to this team were a secret ingredient, what would it be?",
      "What from remote work never readapted you back to in-person?",
      "What was your biggest involuntary humor moment in an important meeting?",
      "If you could give a masterclass on one non-technical thing you master, what would it be?",
      "What don't you have the courage to say out loud in a leadership meeting yet?",
      "If your work were a sentence from a book, what would it be?",
      "What rule at your company today started as someone's crazy idea?",
      "What was your biggest 'I took it seriously when everyone thought it was a joke'?",
      "If you could add one value to your company culture tomorrow, what would it be?",
      "What do you still believe is possible to change in the world of work?",
      "What's your greatest informal facilitation talent that you've never named?",
      "If your ideal work environment were a work of art, what would it be?",
      "What do you know about yourself that you haven't fully accepted yet?",
      "What was your biggest 'it was hard but worth it' leadership moment?",
      "If you had to create a manifesto for your work in three lines, what would it say?",
      "What from corporate past that was buried should be resurrected?",
      "What's your greatest secret for staying calm in the chaos?",
      "If your work were a book chapter, what would the current chapter's title be?",
      "What do you still have to prove to yourself at work?",
      "What was your biggest 'I completely changed my mind' about leadership?",
      "If you could create an opening ritual for meetings that everyone would love, what would it be?",
      "What do you do to stay motivated that would be unpublishable in an HR manual?",
      "What's your biggest 'this failure taught me more than any success'?",
      "What seems serious at work but is fundamentally fun when you see it right?",
      "What was your biggest 'am I in the right place' moment that was followed by certainty?",
      "If you could create a new word for work, what would be the first new word?",
      "What in your area that looks like innovation is just an old thing with a new name?",
      "What's your biggest 'I did it by instinct and then learned it had an academic name'?",
      "If you had to summarize your impact to date in three honest words, what would they be?",
      "What you say you value would be proven by your behaviors today?",
      "What was your biggest 'I believed when nobody else believed'?",
      "If your work were a camera lens, would it be wide angle or telephoto?",
      "What haven't you shared in this room yet that might be relevant to everyone?",
      "What's your biggest 'it's small but it matters' at work?",
      "If you could change one thing about how leaders are developed, what would it be?",
      "What about teamwork do you think is fundamentally a matter of trust?",
      "What was your biggest moment of authenticity that cost you something concrete?",
      "What does everyone do in companies that nobody can explain why?",
      "What's your biggest 'I haven't finished learning this yet'?",
      "If your work were a sound, what sound would it be today?",
      "What have you discovered about yourself through work that you wouldn't have discovered otherwise?",
      "What was your biggest 'it wasn't about work, it was about me'?",
      "If you could create an end-of-year tradition for your team, what would it be?",
      "What about the future of work still genuinely excites you?",
      "If you had to choose a song to describe your current professional state of mind, what would it be?",
      "What have you done at work that would have been better if you'd asked for help?",
      "What was the moment when you most understood that people are the real work?",
      "If your current job title had an honest subtitle, what would it be?",
      "What have you said in a meeting that you're still trying to understand why you said it?",
      "What's your greatest belief about leadership that no book talks about?",
      "If you could redesign one recurring meeting in your life, which would you choose?",
      "What about yourself do you still not know whether it's a strength or a weakness?",
      "When did you feel most genuinely seen at work?",
      "If your work were a recipe, what would be the ingredient everyone forgets but makes all the difference?",
      "What have you learned about yourself in a conflict that you'd never learn at a training?",
      "What's your biggest 'I did the right thing but in the wrong way'?",
      "If your company culture were a smell, what would it be?",
      "What at work gives you a satisfaction you can never completely explain?",
      "What was your biggest 'I was the problem and only realized it afterwards'?",
      "If you had to create an award to celebrate the team's most useful mistakes, what would it be called?",
      "What question about your own leadership do you still don't have an answer to?",
      "What's your biggest 'nobody knows I do this but it keeps everything running'?",
      "If your work were a conversation, what would it be about and with whom?",
      "What have you learned about yourself by watching how others watch you?",
      "What was the moment you most wanted to quit and didn't, and what did you take from it?",
      "If your team were to describe you in one sentence without consulting you, what do you think they'd say?",
      "What about work still surprises you negatively and you don't accept as inevitable?",
      "What's your biggest 'I started doing it out of obligation and ended doing it out of conviction'?",
      "If you could do one thing differently tomorrow morning that would change the tone of your day, what would it be?",
      "What about work that seems technical is actually completely human?",
      "What was your biggest 'the obvious thing I couldn't see'?",
      "If you had to describe your relationship with work as if it were a person, how would that person be?",
      "What from your professional journey would you never include on a CV but defines who you are?",
      "What's your biggest 'I learned to do this the opposite of how it's supposed to be done'?",
      "If you could send an anonymous postcard to someone you've worked with, what would it say?",
      "What haven't you done at work yet that would be the most important thing to do in the next three months?"
    ],
    checkin: [
      "On a phone battery scale, what percentage are you at right now?",
      "What one word describes your state of mind at this moment?",
      "What did you bring with you to this session that wasn't on the agenda?",
      "What part of you is present today and what part stayed at the door?",
      "What do you need to leave outside this room to be fully here?",
      "If your current state were a weather forecast, how would it read?",
      "What gave you energy this week?",
      "What's occupying your mind that isn't this?",
      "Where are you arriving from today?",
      "What do you want us to know before we start?",
      "What honest, unpolished expectation do you have of this session?",
      "In one word, how have you been?",
      "What stopped being urgent for you this week?",
      "What good thing happened since we last saw each other?",
      "What's working well in your work right now?",
      "What challenge are you facing that you can't stop thinking about?",
      "What surprised you positively this week?",
      "What part of your current work gives you the most energy?",
      "What's draining you most this week?",
      "What small thing deserved more recognition than it got?",
      "What do you want to happen in this session that you haven't verbalized yet?",
      "In what part of your work are you growing the most right now?",
      "What assumption about this week was challenged?",
      "What are you most proud of in your recent work?",
      "What question haven't you asked yet but need to?",
      "How's your confidence level right now?",
      "What positive thing did you bring from this week to share?",
      "What would you like to be different right now?",
      "In what situation this week did you feel most like yourself?",
      "What do you need from this team right now that you haven't asked for?",
      "What new thing did you learn about yourself this week?",
      "How's your clarity on what you need to do next?",
      "What genuinely motivated you this week, even if small?",
      "What's asking more of you than you have available?",
      "What from this week was better than expected?",
      "What do you need to name before we begin?",
      "How's your connection to the purpose of the work you do?",
      "What unresolved thing is taking up space in your head?",
      "What gave you genuine pleasure at work this week?",
      "In one sentence, what did this week teach you?",
      "What would you like more time to do?",
      "How's your energy for what comes next?",
      "What made you most vulnerable this week?",
      "What small thing from this week had a disproportionately large impact?",
      "What surprised you about the team this week?",
      "How's your confidence in the people you work with?",
      "What moment from this week would you like to repeat?",
      "What do you need to acknowledge about yourself before we start?",
      "How is your body right now?",
      "What conversation from this week is still working on you?",
      "What from this week was harder than you anticipated?",
      "What would you have done differently?",
      "How's your clarity on priorities?",
      "What's asking more patience from you than you have?",
      "What progress, however small, happened this week?",
      "What's working well that deserves to be named?",
      "What from this week was collective learning?",
      "How's your relationship with uncertainty right now?",
      "What do you need the team to know before we start?",
      "What's still unresolved and is coming into this room with us?",
      "How's your connection to what we do together?",
      "What good thing happened that you haven't celebrated yet?",
      "What from this week was unexpected and positive?",
      "How's your focus level right now?",
      "What's distracting you most this week?",
      "What learning from this week haven't you formalized yet?",
      "How's your sense of control over your work?",
      "What gives you confidence right now?",
      "What from this week made you feel more part of the team?",
      "How's your relationship with what you need to deliver?",
      "What do you need to let go of before you can be present?",
      "What moment this week was of genuine connection?",
      "How's your collaboration mood right now?",
      "What's working well that we could learn from to replicate?",
      "What haven't you said about how you are that's relevant to the group?",
      "How's your sense of safety to share in this group?",
      "What from this week was leadership, formal or informal?",
      "What's still undone that you need to name?",
      "How's your willingness to be challenged today?",
      "What gives you hope in your work right now?",
      "What from this week was good self-management?",
      "How's your connection to the team's goals?",
      "What do you still need to process from this week that's taking up space?",
      "What moment this week was of feedback well given or well received?",
      "How's your relational energy with the team right now?",
      "What from this week was hardest to communicate?",
      "What would you have liked to say sooner?",
      "How's your relationship with change right now?",
      "What made you proud this week, however small?",
      "What from this week is still open and needs to be named?",
      "How's your ability to ask for help right now?",
      "What from this week involved a difficult decision?",
      "What positive thing do you want to bring into this session?",
      "How's your sense of belonging to this team right now?",
      "What from this week was resilience?",
      "What's unresolved between us that needs to be named?",
      "How's your energy to collaborate right now?",
      "What's motivating you most in this specific project?",
      "What from this week involved taking a risk?",
      "How are you, beyond the usual answer?",
      "What is this meeting interrupting that also matters?",
      "What from this week was a moment of unexpected clarity?",
      "How's your willingness to hear different perspectives today?",
      "What haven't you told the team yet that it's time to say?",
      "What from this week was well-handled adaptation?",
      "How's your connection to the purpose of this session?",
      "What's costing you the most to maintain right now?",
      "What learning this week came from an unexpected source?",
      "How's your relationship with the project's uncertainty?",
      "What from this week was genuine teamwork?",
      "What from this week was a sign that something is changing?",
      "How's your willingness for a difficult conversation, if needed?",
      "What do you need to bring to this session that isn't a slide?",
      "What positive thing from this week haven't you acknowledged out loud?",
      "How's your sense of progress on what matters?",
      "What would you like this session to resolve for you?",
      "What from this week was leading by example?",
      "How's your relationship with time and priorities right now?",
      "What's giving you the most satisfaction at work now?",
      "What from this week revealed something about the team's culture?",
      "How's your energy for what we need to do together today?",
      "What from this week was well-managed conflict?",
      "What's still being built inside you right now?",
      "How's your willingness to be honest in this room today?",
      "What from this week was self-knowledge?",
      "What from this week was a moment of leadership without a title?",
      "How's your relationship with feedback right now?",
      "What surprised you about yourself this week?",
      "What from this week was genuine collaboration?",
      "How's your willingness to collaborate with different perspectives?",
      "What good thing about the team's work is still unsaid?",
      "What from this week was humility well lived?",
      "How's your sense of clarity about what you want to do next?",
      "What from this week was managing the chaos?",
      "What do you still need to process before you can move forward?",
      "How's your relationship with what you don't know yet?",
      "What would you like to thank someone for before we start?",
      "What from this week was genuine creativity?",
      "How's your contribution energy for this session?",
      "What do you still need to resolve before the end of this week?",
      "What moment this week was of genuine presence?",
      "How's your connection to the values we say we have as a team?",
      "What from this week was real co-accountability?",
      "What from this week was more about process than people?",
      "How's your willingness to try something different today?",
      "What's weighing on you most right now?",
      "What from this week was autonomy well exercised?",
      "How's your connection to the vision of what we want to create together?",
      "What from this week was managing expectations?",
      "What from this week is still surprising you?",
      "How's your sense of control versus chaos right now?",
      "What from this week was strategic thinking in a tactical context?",
      "What moment this week was genuine exchange and not just transmission?",
      "How's your willingness to change something you know needs to change?",
      "What from this week was reaction and what was conscious choice?",
      "What from this week was real alignment between intention and impact?",
      "How's your innovation energy right now?",
      "What's giving you the most uncertainty in this project?",
      "What from this week was genuine recognition?",
      "How's your relationship with what you can't control?",
      "What from this week was clear and effective communication?",
      "What from today was a sign of progress, however small?",
      "How's your willingness to create space for others today?",
      "What from this week needed more of your attention?",
      "What from this week was learning through experience?",
      "How's your connection to the goals of this specific session?",
      "What's bothering you that you haven't named yet?",
      "What from this week was healthy conflict management?",
      "How's your sense of work rhythm right now?",
      "What from this week was genuine respect for differences?",
      "What from this week was a surprise about the team?",
      "How's your listening capacity right now?",
      "What from this week was shared decision-making?",
      "What from this week made you feel the team culture is improving?",
      "How's your relationship with progress in this sprint or cycle?",
      "What from this week was learning from a different perspective?",
      "What are you bringing here today that has nothing to do with work but will influence the work?",
      "How's your willingness to be influenced today?",
      "What's giving you the most clarity this week?",
      "What from this week was shared leadership?",
      "How's your sense of belonging in this context?",
      "What from this week was good priority management?",
      "What unacknowledged thing from this week deserves to be named?",
      "How's your energy for what we need to decide together?",
      "What from this week was trust placed in another person?",
      "What from this week was courage well exercised?",
      "How's your relationship with what's ambiguous right now?",
      "What would you like this team to know about you after this session?",
      "What from this week was self-confidence gained?",
      "How's your willingness to go deep in conversations today?",
      "What from this week was alignment between what you think and what you do?",
      "What's still unsaid between us that needs to come into this room?",
      "How's your sense of safety to disagree in this group?",
      "What from this week was healthy stress management?",
      "What from this week was unintentional impact that was positive?",
      "How's your relationship with the commitments you've made?",
      "What's giving you the most satisfaction in what you deliver?",
      "What from this week was systems thinking applied?",
      "How's your willingness to be honest about what you don't know?",
      "What from this week was listening before responding?",
      "What from this week was conscious leadership?",
      "How's your connection to the work you're doing right now?",
      "What would you like to leave here before we start?",
      "What from this week was managing your own energy?",
      "How's your willingness to explore instead of conclude today?",
      "What from this week was being fully present in a conversation?",
      "What from today is occupying mental space that you need to name?",
      "How's your sense of flow in your work right now?",
      "What from this week was recognition given to someone else?",
      "What from this week was genuine collective learning?",
      "How's your relationship with your own limits right now?",
      "What do you need to say before you can listen today?",
      "What from this week was feedback given well without being asked for?",
      "How's your willingness to co-create instead of present?",
      "What from this week was clarity about what truly matters?",
      "What's still unnamed about the state of this team?",
      "How's your sense of sustainable pace right now?",
      "What's giving you the most energy to keep going?",
      "What from this week was genuine adaptation to change?",
      "How's your willingness to create instead of criticize today?",
      "What from this week was connection to the greater purpose of the work?",
      "What do you still need to resolve to feel present here?",
      "How's your relationship with what you need to learn?",
      "What's asking more of you than you thought it had?",
      "What from this week was co-accountability well lived?",
      "How's your connection to the impact of your work?",
      "What good thing from this week haven't you shared yet?",
      "What from this week was a calculated risk well executed?",
      "How's your willingness to hear what you don't want to hear today?",
      "What do you need most from this session?",
      "What from this week was respect for divergence?",
      "How's your relationship with what you don't know yet but need to know?",
      "What from this week was integrity applied?",
      "What from today is still working on you?",
      "How's your willingness to ask for what you need?",
      "What from this week was relational courage?",
      "What from this week was a moment of good self-management?",
      "How's your sense of impact in the work you do?",
      "What's helping you most to stay focused?",
      "What from this week was non-verbal communication that mattered?",
      "How's your willingness to go to what's difficult today?",
      "What from this week was generosity at work?",
      "What this week revealed about what you truly contribute to the team?",
      "How's your relationship with what's outside your control?",
      "What from this week was creativity applied to a real problem?",
      "What from this week was a quiet victory that deserves to be named?",
      "How's your willingness to be curious instead of conclusive today?",
      "What from this week was healthy management of tensions?",
      "What from today should have started differently to go better?",
      "How's your willingness to contribute instead of just participate?",
      "What from this week was servant leadership?",
      "What from this week revealed something about your own priorities?",
      "How's your sense of congruence between what you say and what you do?",
      "What from this week was genuine collective decision-making?",
      "What's still unresolved between you and the work that needs space here?",
      "How's your willingness to name the elephant in the room if it appears?",
      "What from this week was visible progress on something that matters?",
      "What from this week was self-knowledge applied?",
      "How's your relationship with the current state of the team?",
      "What good from this week can inform how we move forward together?",
      "What's still open between us that will influence this session?",
      "How's your willingness to co-own instead of point fingers?",
      "What from this week was collective resilience?",
      "What from today is still uncertain and you need to name?",
      "How's your sense of alignment with the team's direction?",
      "What from this week was being present for someone who needed it?",
      "What from this week was creative thinking applied?",
      "How's your willingness to shift position if the conversation asks for it?",
      "What's helping you be better at work right now?",
      "What from this week was unplanned positive impact?",
      "How's your relationship with your own emotions at work?",
      "What from this week was collaboration between different perspectives?",
      "What haven't you said today that might be important for the group?",
      "How's your willingness to acknowledge others' merit today?",
      "What from this week was genuine listening in a difficult conversation?",
      "What from today is influencing how you arrived here?",
      "How's your sense of purpose in what you're contributing?",
      "What from this week was intellectual humility?",
      "What's still unresolved in the team that needs to be said?",
      "How's your attention energy right now?",
      "What from this week was mental agility well exercised?",
      "What from this week was feedback that changed something?",
      "How's your willingness to not have the answers today?",
      "What's giving you the most faith in this team's work?",
      "What haven't you acknowledged about what you've been doing?",
      "How's your connection to the people in this room right now?",
      "What from this week was good rhythm management?",
      "What from this week was genuine curiosity about another point of view?",
      "How's your willingness to bring your best today?",
      "What from this week was leadership without needing recognition?",
      "What good can you still do before this week ends?",
      "How's your sense of clarity about what we need as a team?",
      "What from this week was psychological safety well created?",
      "What from this week is still unnamed and needs to be seen?",
      "How's your willingness to listen before solving?",
      "What's teaching you the most right now?",
      "What from this week was genuine connection with someone?",
      "How are you, honestly, at this exact moment?",
      "What do you want to remain from this session that isn't a deliverable?",
      "If this team were a conversation, what would it be talking about that it isn't talking about yet?"
    ]
  }
};